import { SVGProps, memo } from "react";

const _Brave = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <defs>
      <linearGradient
        x1=".002%"
        y1="100.706%"
        x2="100%"
        y2="100.706%"
        id="brave_a">
        <stop stopColor="#F50" offset="0%" />
        <stop stopColor="#F50" offset="41%" />
        <stop stopColor="#FF2000" offset="58.2%" />
        <stop stopColor="#FF2000" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="2.148%"
        y1="99.635%"
        x2="100%"
        y2="99.635%"
        id="brave_b">
        <stop stopColor="#FF452A" offset="0%" />
        <stop stopColor="#FF2000" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="m247.043 71.966 7.042-17.267s-8.963-9.597-19.845-20.47c-10.877-10.875-33.919-4.477-33.919-4.477L174.083 0H81.922L55.683 29.752s-23.041-6.398-33.919 4.476c-10.882 10.874-19.84 20.47-19.84 20.47l7.043 17.268L0 97.55s26.356 99.75 29.445 111.934c6.08 23.984 10.239 33.256 27.52 45.413 17.276 12.151 48.637 33.256 53.754 36.46 5.122 3.193 11.525 8.642 17.286 8.642 5.76 0 12.159-5.449 17.276-8.643 5.122-3.199 36.478-24.308 53.763-36.46 17.277-12.151 21.44-21.428 27.52-45.412C229.65 197.301 256 97.551 256 97.551l-8.957-25.585Z"
        fill="url(#brave_a)"
        transform="translate(22)"
      />
      <path
        d="M182.733 54.328c3.852 0 32.418-5.432 32.418-5.432S249 89.644 249 98.356c0 7.202-2.915 10.018-6.342 13.342-.716.695-1.46 1.408-2.2 2.197l-25.378 26.838c-.272.285-.548.567-.828.845-2.534 2.535-6.263 6.271-3.635 12.477l.541 1.263c2.886 6.722 6.45 15.022 1.916 23.425-4.826 8.947-13.089 14.919-18.386 13.928-5.292-.986-17.732-7.46-22.304-10.412-4.572-2.957-19.07-14.862-19.07-19.42 0-3.798 10.425-10.117 15.492-13.192 1.007-.61 1.803-1.089 2.26-1.399.522-.352 1.398-.892 2.476-1.558 4.62-2.864 12.967-8.028 13.18-10.314.258-2.826.16-3.652-3.57-10.628-.79-1.483-1.718-3.07-2.674-4.713-3.55-6.08-7.524-12.886-6.64-17.764.99-5.506 9.653-8.66 16.989-11.337.913-.328 1.813-.657 2.67-.98l7.642-2.86c7.326-2.732 15.462-5.769 16.809-6.384 1.855-.85 1.375-1.666-4.252-2.197-.91-.089-1.821-.183-2.73-.281-6.97-.738-19.819-2.094-26.062-.362a503.63 503.63 0 0 1-4.05 1.103c-7.015 1.892-15.617 4.211-16.446 5.549a8.46 8.46 0 0 1-.42.624c-.79 1.118-1.303 1.85-.428 6.6.26 1.418.796 4.202 1.46 7.648 1.93 10.083 4.958 25.81 5.34 29.34.051.497.112.971.169 1.431.485 3.944.805 6.568-3.79 7.615l-1.201.272c-5.189 1.183-12.793 2.925-15.538 2.925-2.75 0-10.359-1.737-15.547-2.925l-1.196-.272c-4.596-1.047-4.27-3.671-3.786-7.615.057-.46.113-.938.165-1.431.381-3.535 3.414-19.304 5.353-29.382.66-3.427 1.192-6.197 1.45-7.605.872-4.751.358-5.483-.433-6.6a17.568 17.568 0 0 1-.423-.625c-.82-1.338-9.417-3.657-16.438-5.549-1.445-.39-2.825-.76-4.049-1.103-6.248-1.737-19.093-.376-26.061.362-1.064.112-1.987.21-2.731.281-5.631.53-6.107 1.347-4.252 2.197 1.342.615 9.478 3.652 16.8 6.384 2.811 1.047 5.509 2.052 7.647 2.86.861.323 1.756.647 2.674.985 7.336 2.676 16 5.826 16.988 11.332.88 4.878-3.093 11.685-6.639 17.764-.96 1.643-1.883 3.23-2.679 4.713-3.724 6.976-3.823 7.802-3.564 10.628.207 2.291 8.55 7.45 13.174 10.314 1.078.666 1.954 1.206 2.477 1.558.461.31 1.252.789 2.26 1.4 5.066 3.07 15.49 9.388 15.49 13.19 0 4.554-14.492 16.464-19.069 19.421-4.567 2.958-17.007 9.426-22.304 10.412-5.292.986-13.56-4.98-18.381-13.923-4.535-8.408-.975-16.708 1.911-23.425l.542-1.268c2.632-6.206-1.097-9.942-3.635-12.477-.279-.278-.553-.56-.824-.845L59.54 113.895c-.744-.784-1.488-1.502-2.203-2.197-3.428-3.32-6.338-6.14-6.338-13.342 0-8.708 33.85-49.46 33.85-49.46s28.56 5.432 32.412 5.432c3.075 0 9.007-2.033 15.194-4.155 1.568-.535 3.15-1.08 4.709-1.596C144.863 46.02 150 46 150 46s5.132.019 12.835 2.577c1.554.517 3.14 1.061 4.709 1.596 6.182 2.122 12.12 4.155 15.19 4.155Zm-4.901 144.145c6.036 3.099 10.32 5.296 11.94 6.305 2.096 1.305.82 3.77-1.092 5.117-1.907 1.338-27.559 21.12-30.045 23.307l-1.012.897c-2.397 2.155-5.457 4.901-7.628 4.901-2.166 0-5.226-2.75-7.627-4.9l-1.003-.898c-2.496-2.187-28.143-21.97-30.05-23.312-1.907-1.342-3.187-3.802-1.092-5.117 1.62-1.004 5.91-3.206 11.955-6.309l5.744-2.953c9.04-4.657 20.317-8.623 22.078-8.623 1.756 0 13.028 3.962 22.078 8.623 2.053 1.061 3.979 2.052 5.754 2.958v.004Z"
        fill="#FFF"
      />
      <path
        d="M200.997 29.722 174.694 0H82.306L56.003 29.722S32.904 23.33 22 34.193c0 0 30.798-2.768 41.382 14.378 0 0 28.548 5.429 32.398 5.429 3.85 0 12.189-3.19 19.888-5.748 7.7-2.558 12.834-2.576 12.834-2.576s5.13.018 12.83 2.576C149.03 50.809 157.37 54 161.22 54c3.85 0 32.403-5.43 32.403-5.43C204.207 31.426 235 34.194 235 34.194c-10.904-10.862-34.003-4.471-34.003-4.471Z"
        fill="url(#brave_b)"
        transform="translate(22)"
      />
    </g>
  </svg>
);
export const Brave = memo(_Brave);
Brave.displayName = "Brave";

const _BraveSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <path
      d="m196.694 0 26.198 29.605.758-.18.655-.146a63.674 63.674 0 0 1 10.05-1.331l.864-.036c7.273-.336 16.152.674 21.781 6.281l-.697-.05-.159-.009.096.094 1.35 1.352 3.616 3.653a954.976 954.976 0 0 1 13.753 14.268l1.126 1.198-7.042 17.267L278 97.55 252.46 194.5a3560.24 3560.24 0 0 0-3.556 13.658l-.882 3.447-.518 1.983c-5.557 20.989-10.204 29.877-26.46 41.31l-2.736 1.917-4.529 3.148c-4.08 2.825-8.522 5.874-12.996 8.927l-10.635 7.226-11.302 7.61c-4.994 3.344-8.926 5.947-10.896 7.208l-.669.424c-5.117 3.194-11.516 8.643-17.276 8.643-5.505 0-11.596-4.975-16.596-8.204l-1.843-1.175c-4.193-2.712-14.896-9.874-26.374-17.669l-7.658-5.217-4.179-2.86a1572.069 1572.069 0 0 1-14.39-9.977c-16.595-11.674-21.09-20.688-26.804-42.625l-3.144-12.15c-2.345-8.979-5.947-22.682-9.765-37.177l-2.01-7.63L22 97.552l8.967-25.585-7.042-17.267 4.646-4.91 3.28-3.421a933.041 933.041 0 0 1 9.89-10.11l2.023-2.03c3.868-3.866 9.273-5.549 14.634-6.112 8.936-.998 17.822 1.144 19.368 1.543L103.922 0h92.772ZM150 186.888c-1.736 0-12.722 3.855-21.695 8.427l-12.221 6.287c-2.833 1.469-4.858 2.55-5.861 3.171-2.043 1.282-.877 3.652.95 5.014l.578.422c1.215.902 4.327 3.28 8.105 6.187l6.681 5.157 7.634 5.932c3.632 2.837 6.448 5.063 7.194 5.717l1.962 1.752c2.217 1.96 4.782 4.046 6.668 4.046 2.17 0 5.231-2.746 7.628-4.9l1.012-.898c1.021-.898 5.95-4.764 11.537-9.102l9.502-7.345c4.608-3.546 8.324-6.382 9.006-6.86 1.912-1.347 3.188-3.812 1.092-5.117l-.387-.234c-1.236-.73-3.467-1.906-6.479-3.461l-10.828-5.572c-.765-.394-1.545-.783-2.335-1.165l-.792-.38-1.177-.55c-7.997-3.694-16.289-6.528-17.774-6.528Zm.11-140.886h-.22c-.786.02-5.684.235-12.725 2.575l-1.565.525-5.972 2.037c-5.116 1.733-9.764 3.189-12.366 3.189l-.228-.005c-1.97-.08-8.086-1.073-14.466-2.189l-4.448-.789c-7.036-1.263-13.27-2.449-13.27-2.449L82.631 51.6C75.106 60.839 51 91.008 51 98.356c0 6.625 2.463 9.543 5.526 12.552l1.682 1.638c.44.432.887.878 1.333 1.349l25.379 26.838.409.425 1.1 1.11c2.454 2.514 5.352 6.122 2.95 11.787l-1.364 3.198c-2.66 6.344-5.199 13.875-1.09 21.495 4.822 8.942 13.09 14.909 18.382 13.923 5.297-.986 17.737-7.454 22.304-10.412l.357-.235c4.927-3.306 18.713-14.744 18.713-19.186 0-3.386-8.27-8.769-13.657-12.074l-3.17-1.929a41.535 41.535 0 0 1-.667-.418l-.547-.36c-.212-.138-.46-.295-.74-.47l-3.11-1.93a175.66 175.66 0 0 1-3.761-2.405l-.608-.404-.855-.579c-3.293-2.257-6.167-4.56-6.287-5.893l-.05-.578c-.173-2.351.143-3.527 3.418-9.682l.196-.368c.455-.848.951-1.729 1.472-2.635l2.323-3.998c3.205-5.556 6.312-11.474 5.523-15.844-.989-5.506-9.652-8.656-16.988-11.332l-1.802-.661a148.61 148.61 0 0 1-.872-.325l-18.935-7.089c-2.796-1.059-4.888-1.868-5.512-2.154l-.19-.09c-1.594-.802-1.011-1.566 4.145-2.078l.888-.087 4.605-.481c7.218-.739 18.027-1.652 23.596-.104l1.653.455 6.365 1.725c5.83 1.602 11.57 3.311 12.423 4.407l.254.38.428.615c.645.957.993 1.934.28 5.97l-.338 1.812-3.49 18.238c-1.445 7.636-2.79 14.985-3.035 17.262l-.053.488-.243 2.044c-.37 3.333-.237 5.568 3.917 6.514l4.793 1.089c4.63 1.035 9.79 2.108 11.95 2.108 1.643 0 5.027-.624 8.591-1.379l1.65-.355 2.067-.458 4.43-1.005c4.33-.987 4.296-3.374 3.872-6.945l-.196-1.611-.089-.78c-.343-2.768-1.828-10.795-3.335-18.735l-3.397-17.786-.033-.176c-.814-4.42-.427-5.362.268-6.371l.16-.23a8.46 8.46 0 0 0 .42-.624c.636-1.026 5.846-2.63 11.405-4.175l3.23-.884 4.206-1.138c.575-.156 1.128-.308 1.655-.455 5.565-1.544 16.377-.634 23.596.104l2.465.258c.91.098 1.82.192 2.731.281 5.627.53 6.107 1.347 4.252 2.197l-.47.201c-1.844.76-7.264 2.796-12.899 4.9l-3.44 1.283-7.642 2.86c-.429.161-.868.324-1.314.488l-2.814 1.026c-6.981 2.566-14.606 5.658-15.53 10.803-.775 4.268 2.171 10.013 5.298 15.455l2.15 3.702a129.19 129.19 0 0 1 1.518 2.678l.733 1.366c3.35 6.314 3.433 7.18 3.183 9.904-.19 2.046-6.892 6.395-11.61 9.339l-3.219 2a46.85 46.85 0 0 0-.536.342l-.546.36c-.378.244-.897.56-1.519.936l-2.32 1.412c-5.387 3.31-13.656 8.691-13.656 12.073 0 4.559 14.497 16.464 19.069 19.421l.55.349c4.95 3.085 16.661 9.115 21.754 10.063 5.297.99 13.56-4.98 18.386-13.928 4.251-7.878 1.384-15.665-1.369-22.146l-1.088-2.542c-2.535-5.988.848-9.677 3.364-12.206l.27-.271c.28-.278.557-.56.83-.845l25.378-26.838c.443-.473.889-.92 1.328-1.35l1.682-1.638c3.064-3.012 5.531-5.926 5.531-12.55 0-7.607-25.797-39.627-32.35-47.638l-1.5-1.823-7.812 1.457c-8.755 1.609-22.063 3.975-24.605 3.975-2.44 0-6.692-1.284-11.438-2.877l-6.897-2.35c-.523-.176-1.045-.352-1.563-.524l-.788-.256c-6.62-2.1-11.182-2.3-11.936-2.319Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export const BraveSimple = memo(_BraveSimple);
BraveSimple.displayName = "BraveSimple";

const _BraveText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 129 40"
    fill="none"
    {...props}>
    <path
      fill="url(#bravetxt_a)"
      fillRule="evenodd"
      d="m33.3 9.58.94-2.3S33.05 6 31.6 4.55c-1.45-1.44-4.51-.6-4.51-.6L23.59 0H11.33l-3.5 3.96s-3.07-.85-4.51.6C1.87 6 .67 7.27.67 7.27l.94 2.3-1.2 3.4s3.52 13.27 3.93 14.9c.8 3.19 1.36 4.42 3.66 6.04 2.3 1.61 6.48 4.42 7.16 4.85.68.42 1.53 1.15 2.3 1.15.77 0 1.62-.73 2.3-1.15.68-.43 4.86-3.24 7.16-4.85 2.3-1.62 2.85-2.85 3.66-6.05.41-1.62 3.92-14.89 3.92-14.89l-1.2-3.4Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M21.8 7.2c.52 0 4.3-.73 4.3-.73s4.5 5.42 4.5 6.58c0 .96-.39 1.34-.84 1.78l-.3.3-3.36 3.57-.11.1c-.34.35-.83.84-.48 1.67l.07.17c.38.9.85 2 .25 3.12-.64 1.19-1.74 1.98-2.44 1.85-.7-.13-2.35-1-2.96-1.39-.6-.39-2.53-1.97-2.53-2.58 0-.5 1.38-1.35 2.06-1.76l.3-.18.32-.21c.62-.38 1.73-1.07 1.75-1.37.04-.38.03-.49-.47-1.42l-.35-.63c-.48-.8-1-1.71-.89-2.36.14-.73 1.29-1.15 2.26-1.51a38.56 38.56 0 0 0 1.37-.51c.97-.37 2.05-.77 2.23-.85.25-.12.18-.22-.57-.3l-.36-.03c-.92-.1-2.63-.28-3.46-.05l-.53.15c-.94.25-2.08.56-2.19.74l-.05.08c-.1.15-.18.24-.06.88l.2 1.02c.25 1.34.65 3.43.7 3.9l.02.2c.07.52.11.87-.5 1l-.16.04c-.69.16-1.7.4-2.06.4a15.24 15.24 0 0 1-2.22-.43c-.61-.14-.57-.5-.5-1.02l.02-.19c.05-.47.45-2.57.7-3.91l.2-1.01c.12-.64.05-.73-.06-.88l-.05-.08c-.11-.18-1.25-.5-2.19-.74l-.53-.15c-.83-.23-2.54-.05-3.46.05l-.37.04c-.74.07-.8.17-.56.29.18.08 1.26.48 2.23.85l1.02.38.35.13c.97.36 2.12.78 2.26 1.5.11.66-.41 1.56-.89 2.37l-.35.63c-.5.93-.5 1.04-.47 1.42.02.3 1.13.99 1.74 1.37l.33.2.3.2c.68.4 2.06 1.24 2.06 1.75 0 .6-1.92 2.2-2.53 2.58-.6.4-2.26 1.26-2.96 1.4-.7.12-1.8-.67-2.44-1.86-.6-1.12-.13-2.23.25-3.12l.07-.17c.35-.83-.14-1.32-.48-1.66l-.1-.11-3.38-3.58-.29-.29c-.46-.44-.84-.82-.84-1.78 0-1.16 4.5-6.58 4.5-6.58s3.78.72 4.3.72c.4 0 1.19-.27 2.01-.55l.63-.21a6.04 6.04 0 0 1 1.7-.35s.68 0 1.7.35l.63.2c.82.3 1.6.56 2.02.56Z"
    />
    <path
      fill="#fff"
      d="M21.15 26.38c.8.42 1.37.7 1.59.84.28.18.1.5-.15.68-.25.18-3.65 2.82-3.98 3.1l-.14.13c-.32.28-.72.65-1.01.65-.29 0-.7-.37-1.01-.65L16.3 31c-.33-.3-3.73-2.93-3.98-3.1-.26-.18-.43-.51-.15-.69.22-.13.78-.42 1.59-.84l.76-.39c1.2-.62 2.7-1.15 2.93-1.15.23 0 1.73.53 2.93 1.15l.76.4Z"
    />
    <path
      fill="#F3F5F7"
      d="M49.87 13.47a7.34 7.34 0 0 1 3.48-.8 7.76 7.76 0 0 1 7.03 4.31 10.25 10.25 0 0 1 1.07 4.79c0 1.82-.35 3.42-1.07 4.82a8.1 8.1 0 0 1-2.91 3.26A7.6 7.6 0 0 1 53.35 31a7.35 7.35 0 0 1-3.48-.78c-1-.53-1.79-1.2-2.38-2.04v2.53H43V7h4.49v8.56a6.38 6.38 0 0 1 2.38-2.09ZM56.22 19a4.57 4.57 0 0 0-8.07.05c-.44.79-.66 1.72-.66 2.79 0 1.06.22 2 .66 2.79.43.79 1.01 1.39 1.73 1.8a4.49 4.49 0 0 0 4.6 0 4.74 4.74 0 0 0 1.74-1.83c.44-.8.66-1.73.66-2.82 0-1.1-.22-2-.66-2.77V19Zm13.33-5.5c.93-.53 1.99-.8 3.19-.8v4.71h-1.2c-1.4 0-2.46.33-3.18 1-.71.66-1.07 1.81-1.07 3.45v8.85H62.8V12.96h4.49v2.75a6.3 6.3 0 0 1 2.26-2.21Zm4.83 3.5a7.84 7.84 0 0 1 2.92-3.2 7.77 7.77 0 0 1 4.12-1.13 7.22 7.22 0 0 1 5.86 2.82v-2.53h4.52V30.7h-4.52v-2.6a6.64 6.64 0 0 1-2.39 2.07 7.31 7.31 0 0 1-3.5.82c-1.5 0-2.86-.39-4.1-1.16a8.06 8.06 0 0 1-2.9-3.25c-.72-1.4-1.08-3-1.08-4.82 0-1.82.36-3.39 1.07-4.78Zm12.26 2.03a4.51 4.51 0 0 0-4.07-2.42A4.57 4.57 0 0 0 78.55 19c-.44.78-.66 1.7-.66 2.77s.22 2 .66 2.8c.44.8 1.01 1.42 1.73 1.85a4.4 4.4 0 0 0 2.29.64c.8 0 1.61-.21 2.34-.63a4.51 4.51 0 0 0 1.73-1.8c.42-.77.64-1.7.64-2.8 0-1.08-.22-2.02-.64-2.8Zm15.66 7.55 4.5-13.62h4.77L105 30.7h-5.45L93 12.96h4.8l4.5 13.62Zm26.25-3.4h-12.97c.1 1.28.55 2.29 1.34 3.01a4.14 4.14 0 0 0 2.92 1.1c1.66 0 2.85-.72 3.55-2.16h4.84a8.07 8.07 0 0 1-2.94 4.22 8.6 8.6 0 0 1-5.36 1.65c-1.7 0-3.24-.38-4.6-1.14a8 8 0 0 1-3.17-3.22 9.86 9.86 0 0 1-1.13-4.8c0-1.82.37-3.46 1.12-4.84a7.8 7.8 0 0 1 3.14-3.2 9.41 9.41 0 0 1 4.64-1.13c1.75 0 3.2.36 4.54 1.1a7.68 7.68 0 0 1 3.1 3.08 9.38 9.38 0 0 1 1.11 4.6c0 .64-.04 1.22-.13 1.73Zm-4.52-3.01a3.55 3.55 0 0 0-1.25-2.77 4.42 4.42 0 0 0-2.97-1.04c-1.12 0-2.05.33-2.8 1a4.42 4.42 0 0 0-1.4 2.8h8.43Z"
    />
    <defs>
      <linearGradient
        id="bravetxt_a"
        x1=".42"
        x2="34.5"
        y1="40.2"
        y2="40.2"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF5601" />
        <stop offset=".5" stopColor="#FF4000" />
        <stop offset="1" stopColor="#FF1F01" />
      </linearGradient>
    </defs>
  </svg>
);
export const BraveText = memo(_BraveText);
BraveText.displayName = "BraveText";

const _Coinbase = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 150c0 82.844 67.156 150 150 150s150-67.156 150-150S232.844 0 150 0 0 67.156 0 150Z"
        fill="#0052FF"
      />
      <path
        d="M111.67 101.665c-5.523 0-10.005 4.482-10.005 10.006v76.658c0 5.524 4.482 10.006 10.006 10.006h76.658c5.524 0 10.006-4.482 10.006-10.006v-76.658c0-5.524-4.482-10.006-10.006-10.006h-76.658Z"
        fill="#FFF"
      />
    </g>
  </svg>
);
export const Coinbase = memo(_Coinbase);
Coinbase.displayName = "Coinbase";

const _CoinbaseSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <path
      d="M150 0c82.844 0 150 67.156 150 150s-67.156 150-150 150S0 232.844 0 150 67.156 0 150 0Zm38.33 101.665h-76.66c-5.523 0-10.005 4.482-10.005 10.006v76.658c0 5.524 4.482 10.006 10.006 10.006h76.658c5.524 0 10.006-4.482 10.006-10.006v-76.658c0-5.524-4.482-10.006-10.006-10.006Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export const CoinbaseSimple = memo(_CoinbaseSimple);
CoinbaseSimple.displayName = "CoinbaseSimple";

const _CoinbaseText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 359 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M72.31 17.868c-13.016 0-23.186 9.88-23.186 23.106 0 13.227 9.913 23.023 23.185 23.023 13.273 0 23.358-9.965 23.358-23.107 0-13.058-9.913-23.022-23.358-23.022Zm.087 36.597c-7.412 0-12.843-5.757-12.843-13.487 0-7.819 5.344-13.572 12.755-13.572 7.5 0 12.928 5.841 12.928 13.572 0 7.73-5.428 13.487-12.84 13.487ZM98.51 27.92h6.465v35.221h10.342V18.726H98.509v9.194Zm-75.412-.517c5.431 0 9.74 3.35 11.376 8.332H45.42c-1.984-10.65-10.774-17.867-22.235-17.867C10.17 17.868 0 27.748 0 40.978 0 54.208 9.913 64 23.185 64c11.204 0 20.167-7.217 22.15-17.955H34.474c-1.551 4.982-5.86 8.42-11.291 8.42-7.5 0-12.755-5.757-12.755-13.487.003-7.819 5.174-13.575 12.67-13.575Zm271.916 9.279-7.584-1.116c-3.619-.514-6.205-1.717-6.205-4.553 0-3.093 3.363-4.638 7.929-4.638 4.999 0 8.189 2.147 8.878 5.669h9.998c-1.122-8.934-8.017-14.173-18.616-14.173-10.947 0-18.186 5.584-18.186 13.487 0 7.558 4.741 11.942 14.306 13.314l7.584 1.116c3.708.514 5.776 1.977 5.776 4.725 0 3.522-3.619 4.983-8.618 4.983-6.121 0-9.568-2.492-10.085-6.27h-10.17C270.97 57.901 277.777 64 290.187 64c11.292 0 18.788-5.155 18.788-14.004 0-7.903-5.428-12.027-13.962-13.315ZM110.145.428c-3.792 0-6.637 2.748-6.637 6.527 0 3.78 2.842 6.528 6.637 6.528 3.792 0 6.638-2.748 6.638-6.528 0-3.779-2.846-6.527-6.638-6.527Zm151.774 33.504c0-9.62-5.86-16.062-18.271-16.062-11.721 0-18.271 5.929-19.565 15.035h10.257c.517-3.522 3.275-6.443 9.136-6.443 5.259 0 7.844 2.319 7.844 5.155 0 3.694-4.742 4.637-10.602 5.24-7.929.858-17.754 3.606-17.754 13.915 0 7.991 5.948 13.142 15.429 13.142 7.411 0 12.065-3.092 14.394-7.99.345 4.38 3.62 7.216 8.189 7.216h6.033v-9.19h-5.087V33.933h-.003Zm-10.17 11.169c0 5.928-5.171 10.309-11.464 10.309-3.879 0-7.154-1.633-7.154-5.067 0-4.38 5.258-5.584 10.085-6.098 4.654-.43 7.239-1.46 8.533-3.437v4.293Zm-54.9-27.234c-5.776 0-10.602 2.406-14.049 6.442V0h-10.342v63.141h10.169v-5.84c3.447 4.208 8.362 6.699 14.222 6.699 12.41 0 21.806-9.792 21.806-23.022 0-13.23-9.568-23.11-21.806-23.11Zm-1.551 36.597c-7.412 0-12.843-5.757-12.843-13.487s5.516-13.572 12.927-13.572c7.5 0 12.755 5.757 12.755 13.572 0 7.73-5.428 13.487-12.839 13.487Zm-47.577-36.597c-6.722 0-11.119 2.748-13.704 6.615v-5.757h-10.258v44.412h10.342V39c0-6.787 4.309-11.597 10.687-11.597 5.948 0 9.652 4.208 9.652 10.31V63.14h10.342v-26.2c.004-11.17-5.769-19.073-17.061-19.073Zm210.554 21.65c0-12.713-9.308-21.647-21.806-21.647-13.272 0-23.012 9.965-23.012 23.107 0 13.831 10.429 23.022 23.185 23.022 10.774 0 19.22-6.358 21.373-15.376H347.24c-1.551 3.951-5.343 6.185-10.429 6.185-6.638 0-11.637-4.123-12.756-11.34h34.217v-3.952h.003ZM324.66 36.08c1.64-6.186 6.293-9.19 11.637-9.19 5.86 0 10.342 3.349 11.376 9.19H324.66Z"
      fill="#0052FF"
    />
  </svg>
);
export const CoinbaseText = memo(_CoinbaseText);
CoinbaseText.displayName = "CoinbaseText";

const _Ctrl = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <path
      d="M300 0v300H0V0h300Zm-62.36 116.665h-41.93c-6.827.004-12.358 5.538-12.358 12.364v21.99a32.304 32.304 0 0 1-32.299 32.31h-21.99c-6.828 0-12.363 5.535-12.363 12.363h-.029v41.954c0 6.834 5.535 12.358 12.358 12.358h41.948c6.828 0 12.363-5.535 12.363-12.363v-20.978c0-9.215 3.72-17.548 9.76-23.57a33.22 33.22 0 0 1 23.57-9.764h20.976c6.826-.003 12.358-5.538 12.358-12.363v-41.937c0-6.828-5.535-12.364-12.363-12.364Zm-66.663-66.663h-41.931c-6.84 0-12.358 5.54-12.358 12.357v21.99c-.003 17.84-14.465 32.3-32.304 32.3H62.365c-6.828 0-12.363 5.534-12.363 12.362v41.966a12.357 12.357 0 0 0 12.357 12.363h41.949c6.828 0 12.363-5.535 12.363-12.363V150a33.169 33.169 0 0 1 9.765-23.564A33.226 33.226 0 0 1 150 116.67h20.977c6.828 0 12.363-5.535 12.363-12.363V62.365c0-6.828-5.535-12.363-12.363-12.363Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export const Ctrl = memo(_Ctrl);
Ctrl.displayName = "Ctrl";

const _CtrlText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 159.993 52.414"
    {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M52.414 0v52.414H0V0h52.414ZM41.519 20.383h-7.326a2.16 2.16 0 0 0-2.159 2.16v3.842a5.644 5.644 0 0 1-5.643 5.645h-3.842a2.16 2.16 0 0 0-2.16 2.16l-.005 7.33c0 1.194.967 2.159 2.159 2.159h7.329a2.16 2.16 0 0 0 2.16-2.16v-3.665c0-1.61.65-3.066 1.705-4.118a5.804 5.804 0 0 1 4.118-1.706h3.665a2.16 2.16 0 0 0 2.159-2.16v-7.327a2.16 2.16 0 0 0-2.16-2.16ZM29.872 8.736h-7.326a2.158 2.158 0 0 0-2.159 2.159v3.842a5.644 5.644 0 0 1-5.644 5.643h-3.847a2.16 2.16 0 0 0-2.16 2.16v7.332a2.159 2.159 0 0 0 2.159 2.16h7.329a2.16 2.16 0 0 0 2.16-2.16v-3.665a5.795 5.795 0 0 1 1.706-4.117 5.805 5.805 0 0 1 4.117-1.706h3.665a2.16 2.16 0 0 0 2.16-2.16v-7.328a2.16 2.16 0 0 0-2.16-2.16ZM117.773 7.508v9.247h6.796v5.042h-6.796v18.572c0 1.723.352 2.86 1.061 3.42.71.558 1.989.838 3.832.838h1.903v5.035h-2.161c-2.831 0-5.026-.226-6.59-.672-1.565-.459-2.719-1.33-3.448-2.62a6.817 6.817 0 0 1-.676-1.743c-.279-1.071-.418-2.355-.418-3.872V21.79h-4.767v-5.042h4.767V9.783l6.497-2.275Zm35.789-4.198h6.431v46.22h-6.431V3.31Zm-17.755 25.565v-12.12h-6.498v32.774h6.498V37.003c.04-3.658.524-6.572 1.445-8.747.922-2.175 2.413-3.812 4.469-4.91 2.062-1.097 4.826-1.755 8.301-1.968v-5.681c-2.957 0-5.364.432-7.207 1.29-1.843.859-3.302 2.249-4.376 4.165-1.074 1.915-1.863 4.483-2.38 7.716h-.259l.007.007Zm-32.262-8.955c.034.22.067.453.093.686.013.087.02.173.033.26M96.319 31.05h6.974c-.053.3-.099.612-.132.924-.02.153-.04.307-.053.46-.053.419-.113.811-.179 1.17-.497 2.754-1.459 5.235-2.878 7.457-1.697 2.654-3.998 4.73-6.895 6.22-2.89 1.49-6.252 2.242-10.064 2.242h-1.253c-4.197 0-7.903-.952-11.112-2.84-3.209-1.897-5.682-4.59-7.426-8.083-1.743-3.492-2.612-7.597-2.612-12.313s.869-8.8 2.612-12.253c1.744-3.446 4.204-6.1 7.4-7.956 3.182-1.836 6.895-2.767 11.131-2.767h1.253c3.82 0 7.187.745 10.104 2.242 2.918 1.496 5.225 3.572 6.922 6.22 1.545 2.407 2.539 5.115 2.997 8.148.033.22.066.452.093.685.013.087.02.173.033.26.04.299.066.611.093.924h-6.935c-.04-.313-.087-.625-.133-.924h-.007a1.378 1.378 0 0 0-.026-.167l-.438-2.009s0-.02-.006-.04c-.697-2.467-1.936-4.55-3.713-6.246-2.287-2.188-5.278-3.28-8.97-3.28h-1.254c-2.81 0-5.297.686-7.458 2.056-2.155 1.37-3.826 3.346-5 5.934-1.18 2.594-1.763 5.647-1.763 9.186 0 3.54.584 6.62 1.764 9.253 1.173 2.628 2.844 4.65 4.999 6.06 2.161 1.41 4.647 2.116 7.459 2.116h1.252c3.607 0 6.558-1.105 8.845-3.313a13.96 13.96 0 0 0 2.771-3.752v-.007c.338-.671.63-1.376.862-2.115.04-.113.067-.22.1-.332.205-.679.37-1.397.49-2.142a.23.23 0 0 1 .014-.067h.052c.027-.313.054-.625.093-.925l-.006-.026Z" />
    </g>
  </svg>
);
export const CtrlText = memo(_CtrlText);
CtrlText.displayName = "CtrlText";

const _Daodao = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    <g stroke="none" fill="none">
      <path
        d="M14,0 C6.26801,0 0,6.26801 0,14 C0,21.732 6.26801,28 14,28 C21.732,28 28,21.732 28,14 C28,6.26801 21.732,0 14,0 Z"
        fill="#000000"
        fillRule="evenodd"></path>
      <circle
        fill="currentColor"
        fillRule="nonzero"
        transform="translate(8.5, 14) rotate(-180) translate(-8.5, -14)"
        cx="8.5"
        cy="14"
        r="1.5"></circle>
      <path
        d="M14,0 C6.26801,0 0,6.26801 0,14 C0,21.732 6.26801,28 14,28 C21.732,28 28,21.732 28,14 C28,6.26801 21.732,0 14,0 Z M14,1.25 C6.95837,1.25 1.25,6.95837 1.25,14 C1.25,21.0416 6.95837,26.75 14,26.75 C21.0416,26.75 26.75,21.0416 26.75,14 C26.75,6.95837 21.0416,1.25 14,1.25 Z"
        fill="currentColor"
        fillRule="evenodd"></path>
      <path
        d="M14,14 C14,17.0376 16.4624,19.5 19.5,19.5 C22.5376,19.5 25,17.0376 25,14 C25,7.92487 20.0751,3 14,3 C7.92487,3 3,7.92487 3,14 C3,10.9624 5.46243,8.5 8.5,8.5 C11.5376,8.5 14,10.9624 14,14 Z M19.5,12.5 C18.6716,12.5 18,13.1716 18,14 C18,14.8284 18.6716,15.5 19.5,15.5 C20.3284,15.5 21,14.8284 21,14 C21,13.1716 20.3284,12.5 19.5,12.5 Z"
        fill="currentColor"
        fillRule="evenodd"></path>
    </g>
  </svg>
);
export const Daodao = memo(_Daodao);
Daodao.displayName = "Daodao";

const _Keplr = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 42 42"
    fill="none"
    {...props}>
    <g clipPath="url(#keplr_a)">
      <path
        fill="url(#keplr_b)"
        d="M32.455 0H9.545A9.545 9.545 0 0 0 0 9.545v22.91A9.545 9.545 0 0 0 9.545 42h22.91A9.545 9.545 0 0 0 42 32.455V9.545A9.545 9.545 0 0 0 32.455 0Z"
      />
      <path
        fill="url(#keplr_c)"
        d="M32.455 0H9.545A9.545 9.545 0 0 0 0 9.545v22.91A9.545 9.545 0 0 0 9.545 42h22.91A9.545 9.545 0 0 0 42 32.455V9.545A9.545 9.545 0 0 0 32.455 0Z"
      />
      <path
        fill="url(#keplr_d)"
        d="M32.455 0H9.545A9.545 9.545 0 0 0 0 9.545v22.91A9.545 9.545 0 0 0 9.545 42h22.91A9.545 9.545 0 0 0 42 32.455V9.545A9.545 9.545 0 0 0 32.455 0Z"
      />
      <path
        fill="url(#keplr_e)"
        d="M32.455 0H9.545A9.545 9.545 0 0 0 0 9.545v22.91A9.545 9.545 0 0 0 9.545 42h22.91A9.545 9.545 0 0 0 42 32.455V9.545A9.545 9.545 0 0 0 32.455 0Z"
      />
      <path
        fill="#fff"
        d="M17.253 32.261V22.52l9.465 9.742h5.267v-.253L21.096 20.912l10.05-10.526v-.125h-5.3l-8.593 9.303V10.26h-4.268v22h4.268Z"
      />
    </g>
    <defs>
      <radialGradient
        id="keplr_c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(47.49745 -47.75613 48.47062 48.20806 2.006 40.409)"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#232DE3" />
        <stop offset={1} stopColor="#232DE3" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="keplr_d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-138.45 27.79 13.343) scale(42.1137 64.2116)"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#8B4DFF" />
        <stop offset={1} stopColor="#8B4DFF" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="keplr_e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 33.1135 -80.3423 0 20.65 .311)"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#24D5FF" />
        <stop offset={1} stopColor="#1BB8FF" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="keplr_b"
        x1={21}
        x2={21}
        y1={0}
        y2={42}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#1FD1FF" />
        <stop offset={1} stopColor="#1BB8FF" />
      </linearGradient>
      <clipPath id="keplr_a">
        <path fill="#fff" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const Keplr = memo(_Keplr);
Keplr.displayName = "Keplr";

const _KeplrSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <path
      d="M231.821 0C269.475 0 300 30.525 300 68.179V231.82C300 269.475 269.475 300 231.821 300H68.18C30.525 300 0 269.475 0 231.821V68.18C0 30.525 30.525 0 68.179 0ZM123.55 73H93v156.986h30.55v-69.502L191.3 230H229v-1.805l-77.942-79.185 71.937-75.11v-.893h-37.937l-61.508 66.384V73Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export const KeplrSimple = memo(_KeplrSimple);
KeplrSimple.displayName = "KeplrSimple";

const _KeplrText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 119 40"
    {...props}>
    <path
      d="M52.675 29.064v-9.038l8.902 9.038h4.96v-.235l-10.24-10.291 9.442-9.767v-.117h-4.986l-8.082 8.63v-8.63h-4.006v20.41h4.01Zm20.74.436c2.309 0 4.83-.786 6.44-2.332l-2.37-2.244c-.88.844-2.643 1.346-4.01 1.346-2.643 0-4.224-1.283-4.466-3.061h11.686c.032-.466.062-.904.062-1.347 0-5.015-3.04-7.55-7.626-7.55-4.862 0-7.96 3.147-7.96 7.522.005 4.576 3.074 7.666 8.24 7.666h.003Zm3.736-9.241h-8.086c.576-1.867 2.158-2.8 4.188-2.8 2.162 0 3.653.933 3.894 2.8h.004Zm8.917 15.393v-8.28c1.092 1.603 3.371 2.1 4.985 2.1 4.802 0 7.566-3.383 7.566-7.58 0-4.231-3.07-7.523-7.688-7.523-1.701 0-3.675.67-4.86 2.307l-.243-1.982h-3.472v20.96l3.712-.002Zm4.586-9.65c-2.552 0-4.253-1.867-4.253-4.11 0-2.245 1.581-4.083 4.253-4.083s4.253 1.836 4.253 4.082c0 2.246-1.704 4.112-4.257 4.112h.004Zm13.475 3.062V8.68h-3.682v20.383h3.682Zm6.453 0v-7.58c0-2.693 1.794-3.654 3.737-3.654 1.216 0 1.914.385 2.675.935l1.671-3.093c-.82-.728-2.31-1.346-3.859-1.346-1.488 0-3.129.262-4.224 2.012l-.273-1.662h-3.439V29.05l3.712.014Z"
      fill="#fff"
    />
    <path
      d="M0 17c0-6.547 0-9.82 1.474-12.225a10 10 0 0 1 3.301-3.301C7.18 0 10.453 0 17 0h6c6.547 0 9.82 0 12.225 1.474a10 10 0 0 1 3.301 3.301C40 7.18 40 10.453 40 17v6c0 6.547 0 9.82-1.474 12.225a9.999 9.999 0 0 1-3.301 3.301C32.82 40 29.547 40 23 40h-6c-6.547 0-9.82 0-12.225-1.474a9.999 9.999 0 0 1-3.301-3.301C0 32.82 0 29.547 0 23v-6Z"
      fill="url(#kt_a)"
    />
    <path
      d="M0 17c0-6.547 0-9.82 1.474-12.225a10 10 0 0 1 3.301-3.301C7.18 0 10.453 0 17 0h6c6.547 0 9.82 0 12.225 1.474a10 10 0 0 1 3.301 3.301C40 7.18 40 10.453 40 17v6c0 6.547 0 9.82-1.474 12.225a9.999 9.999 0 0 1-3.301 3.301C32.82 40 29.547 40 23 40h-6c-6.547 0-9.82 0-12.225-1.474a9.999 9.999 0 0 1-3.301-3.301C0 32.82 0 29.547 0 23v-6Z"
      fill="url(#kt_b)"
    />
    <path
      d="M0 17c0-6.547 0-9.82 1.474-12.225a10 10 0 0 1 3.301-3.301C7.18 0 10.453 0 17 0h6c6.547 0 9.82 0 12.225 1.474a10 10 0 0 1 3.301 3.301C40 7.18 40 10.453 40 17v6c0 6.547 0 9.82-1.474 12.225a9.999 9.999 0 0 1-3.301 3.301C32.82 40 29.547 40 23 40h-6c-6.547 0-9.82 0-12.225-1.474a9.999 9.999 0 0 1-3.301-3.301C0 32.82 0 29.547 0 23v-6Z"
      fill="url(#kt_c)"
    />
    <path
      d="M0 17c0-6.547 0-9.82 1.474-12.225a10 10 0 0 1 3.301-3.301C7.18 0 10.453 0 17 0h6c6.547 0 9.82 0 12.225 1.474a10 10 0 0 1 3.301 3.301C40 7.18 40 10.453 40 17v6c0 6.547 0 9.82-1.474 12.225a9.999 9.999 0 0 1-3.301 3.301C32.82 40 29.547 40 23 40h-6c-6.547 0-9.82 0-12.225-1.474a9.999 9.999 0 0 1-3.301-3.301C0 32.82 0 29.547 0 23v-6Z"
      fill="url(#kt_d)"
    />
    <path
      d="M15.265 31v-9.744L24.733 31H30v-.253L19.11 19.654 29.16 9.127V9h-5.3l-8.595 9.302V9H11v22h4.265Z"
      fill="#fff"
    />
    <defs>
      <radialGradient
        id="kt_b"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45.156 47.232 16.945) scale(64.1474 65.107)">
        <stop stopColor="#232DE3" />
        <stop offset="1" stopColor="#232DE3" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="kt_c"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-138.45 26.467 12.707) scale(40.1083 61.1539)">
        <stop stopColor="#8B4DFF" />
        <stop offset="1" stopColor="#8B4DFF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="kt_d"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 31.5366 -76.5164 0 19.667 .297)">
        <stop stopColor="#24D5FF" />
        <stop offset="1" stopColor="#1BB8FF" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="kt_a"
        x1="20"
        y1="0"
        x2="20"
        y2="40"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#1FD1FF" />
        <stop offset="1" stopColor="#1BB8FF" />
      </linearGradient>
    </defs>
  </svg>
);
export const KeplrText = memo(_KeplrText);
KeplrText.displayName = "KeplrText";

const _Leap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
      <g fillRule="nonzero" fill="none">
        <path
          d="M270.22 186.832c0 21.417-13.031 36.484-34.191 46.203-21.164 9.72-50.443 14.083-82.891 14.083-32.448 0-61.918-4.362-83.272-14.083-21.35-9.72-34.572-24.788-34.572-46.203 0-21.424 13.136-40.817 34.396-54.859 21.259-14.04 50.63-22.723 83.067-22.723 32.437 0 61.808 8.7 83.068 22.752 21.26 14.051 34.396 33.444 34.396 54.83Z"
          fill="#24A95A"
        />
        <path
          d="m185.317 67.856.061.014.041-.049C192.937 58.793 204.327 53 217.084 53c22.629 0 41.004 18.207 41.004 40.626a40.232 40.232 0 0 1-5.391 20.162l-.027.046.023.049c3.267 6.926 5.015 14.302 5.015 21.98 0 19.754-11.735 37.639-30.729 50.59-18.993 12.95-45.236 20.959-74.222 20.959-28.985 0-55.228-8.01-74.221-20.96-18.994-12.95-30.729-30.835-30.729-50.59 0-7.677 1.747-15.053 5.015-21.98l.023-.048-.027-.046c-3.417-5.944-5.392-12.79-5.392-20.162C47.426 71.206 65.802 53 88.431 53c12.68 0 24.071 5.793 31.665 14.822l.041.048.061-.014c10.27-2.337 21.224-3.543 32.56-3.543a151.7 151.7 0 0 1 32.559 3.543Z"
          fill="#32DA6D"
        />
        <path
          d="M85.478 116.97c13.706 0 24.816-11.11 24.816-24.816 0-13.705-11.11-24.816-24.816-24.816s-24.816 11.11-24.816 24.816 11.11 24.817 24.816 24.817ZM218.934 116.97c13.706 0 24.816-11.11 24.816-24.816 0-13.705-11.11-24.816-24.816-24.816s-24.816 11.11-24.816 24.816 11.11 24.817 24.816 24.817Z"
          fill="#FFF"
        />
        <path
          d="M16.235 229.576a.875.875 0 0 0 .096-.038l-.001-.004-.006-.015-.024-.06-.091-.239a284.512 284.512 0 0 1-1.638-4.413 376.286 376.286 0 0 1-4.175-12.204c-3.218-9.96-6.937-22.898-8.938-34.822C.457 171.82-.115 166.115.019 161.165c.134-4.952.974-9.136 2.784-12.066 1.805-2.923 4.579-4.605 8.61-4.554 4.042.052 9.353 1.845 16.215 5.897 41.24 24.346 50.618 64.823 52.83 83.522.602 5.218-3.62 9.845-8.979 9.845H7.002c-4.247 0-5.805-5.521-2.085-7.655l11.37-6.488.077-.045-.033-.082-.096.037ZM285.226 229.542l.098.034a2.596 2.596 0 0 1-.098-.035l.002-.004.005-.015.02-.06.084-.239a236.334 236.334 0 0 0 1.482-4.414 403.887 403.887 0 0 0 3.779-12.202c2.912-9.96 6.277-22.9 8.086-34.824.905-5.962 1.42-11.667 1.298-16.618-.123-4.953-.886-9.139-2.527-12.07-.82-1.465-1.858-2.613-3.143-3.39-1.285-.777-2.823-1.185-4.649-1.16-3.656.052-8.464 1.842-14.678 5.894-37.264 24.345-45.82 64.897-47.73 83.523-.53 5.232 3.256 9.847 8.076 9.847h58.401c1.89 0 3.195-1.37 3.607-3.025.412-1.654-.076-3.567-1.751-4.632l-10.362-6.61Zm0 0-.027.077.07.044 10.318 6.489-10.361-6.61Z"
          fill="#32DA6D"
        />
        <path
          d="M85.478 107.044c8.223 0 14.89-6.666 14.89-14.89 0-8.223-6.667-14.89-14.89-14.89s-14.89 6.667-14.89 14.89c0 8.224 6.667 14.89 14.89 14.89ZM218.934 107.044c8.223 0 14.89-6.666 14.89-14.89 0-8.223-6.667-14.89-14.89-14.89s-14.89 6.667-14.89 14.89c0 8.224 6.667 14.89 14.89 14.89ZM193.015 151.51a40.873 40.873 0 0 1-4.382 15.228 40.578 40.578 0 0 1-9.832 12.379 40.24 40.24 0 0 1-13.786 7.646 40.047 40.047 0 0 1-30.755-2.666 40.386 40.386 0 0 1-12.287-9.906 40.735 40.735 0 0 1-7.59-13.889 40.923 40.923 0 0 1-1.735-15.758l40.184 3.483 40.183 3.483Z"
          fill="#092511"
        />
      </g>
    </svg>
  </svg>
);
export const Leap = memo(_Leap);
Leap.displayName = "Leap";

const _LeapSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M217.084 53c22.629 0 41.004 18.207 41.004 40.626 0 7.149-1.856 13.803-5.084 19.62l-.334.588.023.049c3.267 6.926 5.015 14.302 5.015 21.98 0 4.686-.66 9.268-1.922 13.703 2.713 3.263 5.081 6.669 7.072 10.195a99.113 99.113 0 0 1 12.127-9.322c6.214-4.052 11.022-5.842 14.678-5.894 1.826-.025 3.364.383 4.649 1.16 1.285.777 2.323 1.925 3.143 3.39 1.641 2.931 2.404 7.117 2.527 12.07.123 4.95-.393 10.656-1.298 16.618-1.7 11.201-4.772 23.299-7.552 32.98l-.534 1.844c-1.457 4.979-2.8 9.214-3.779 12.202l-.662 2.001-.82 2.413-.11.314.019.01.04.016-.06-.02-.027.076 10.389 6.533c1.608 1.023 2.122 2.827 1.796 4.432l-.045.2c-.412 1.654-1.717 3.025-3.607 3.025h-58.4c-3.999 0-7.285-3.175-7.987-7.243-20.17 7.253-45.991 10.552-74.207 10.552-27.477 0-52.818-3.128-72.904-9.989-.993 3.789-4.52 6.68-8.755 6.68H7.002c-4.247 0-5.805-5.521-2.085-7.655l11.447-6.533-.826-2.179a302.87 302.87 0 0 1-.967-2.635l-.726-2.026a379.543 379.543 0 0 1-3.248-9.559l-.791-2.461c-3.073-9.682-6.468-21.779-8.348-32.98C.457 171.82-.115 166.115.019 161.165c.134-4.952.974-9.136 2.784-12.066 1.805-2.923 4.579-4.605 8.61-4.554 4.042.052 9.353 1.845 16.215 5.897a108.94 108.94 0 0 1 14.512 10.221c2.092-3.858 4.633-7.575 7.583-11.123a49.905 49.905 0 0 1-1.916-13.678c0-7.43 1.636-14.577 4.703-21.308l.335-.72-.027-.046c-3.417-5.944-5.392-12.79-5.392-20.162C47.426 71.206 65.802 53 88.431 53c12.489 0 23.726 5.619 31.318 14.413l.388.457.061-.014c10.27-2.337 21.224-3.543 32.56-3.543 10.915 0 21.477 1.189 31.415 3.296l1.205.26.041-.048C192.937 58.793 204.327 53 217.084 53Zm-104.436 91.544a40.923 40.923 0 0 0 1.736 15.758 40.735 40.735 0 0 0 7.59 13.89 40.386 40.386 0 0 0 12.286 9.905 40.105 40.105 0 0 0 18.558 4.565l.689-.006c3.9-.066 7.776-.701 11.508-1.893a40.24 40.24 0 0 0 13.786-7.646 40.578 40.578 0 0 0 9.832-12.38 40.873 40.873 0 0 0 4.382-15.227l-80.367-6.966Zm-27.17-77.206c-13.706 0-24.816 11.11-24.816 24.816s11.11 24.817 24.816 24.817 24.816-11.111 24.816-24.817c0-13.705-11.11-24.816-24.816-24.816Zm133.456 0c-13.706 0-24.816 11.11-24.816 24.816s11.11 24.817 24.816 24.817 24.816-11.111 24.816-24.817c0-13.705-11.11-24.816-24.816-24.816ZM85.478 77.265c8.223 0 14.89 6.666 14.89 14.89 0 8.223-6.667 14.89-14.89 14.89s-14.89-6.667-14.89-14.89c0-8.224 6.667-14.89 14.89-14.89Zm133.456 0c8.223 0 14.89 6.666 14.89 14.89 0 8.223-6.667 14.89-14.89 14.89s-14.89-6.667-14.89-14.89c0-8.224 6.667-14.89 14.89-14.89Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export const LeapSimple = memo(_LeapSimple);
LeapSimple.displayName = "LeapSimple";

const _LeapText = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199 58" {...props}>
    <g fillRule="nonzero" fill="none">
      <path
        d="M64 32.567C64 42.83 51.55 47 36.09 47 20.633 47 8 42.83 8 32.567S20.541 14 36 14s28 8.323 28 18.567Z"
        fill="#24A95A"
      />
      <path
        d="M61 9.746C61 4.368 56.632 0 51.253 0a9.73 9.73 0 0 0-7.095 3.066 1.16 1.16 0 0 1-1.07.354A35.681 35.681 0 0 0 36 2.707c-2.456 0-4.837.241-7.088.71a1.16 1.16 0 0 1-1.073-.35C26.049 1.183 23.529 0 20.747 0 15.368 0 11 4.368 11 9.746a9.712 9.712 0 0 0 1.02 4.345c.155.313.17.68.036 1.003a12.284 12.284 0 0 0-.966 4.76C11.09 29.329 22.246 37 36 37s24.91-7.67 24.91-17.146c0-1.654-.335-3.25-.966-4.76a1.209 1.209 0 0 1 .037-1.003A9.713 9.713 0 0 0 61 9.746Z"
        fill="#32DA6D"
      />
      <path
        d="M19.999 15a6 6 0 0 0 5.999-6 6 6 0 1 0-6 6ZM52 15A6 6 0 0 0 58 9a6 6 0 1 0-11.997 0A6 6 0 0 0 52 15Z"
        fill="#FFF"
      />
      <path
        d="M17.166 46c1.3 0 2.325-1.129 2.178-2.403-.53-4.515-2.781-14.29-12.681-20.17-10.852-6.448-5.69 10.694-3.531 16.94.437 1.263-.07 2.666-1.229 3.331l-.711.409C.277 44.635.66 46 1.704 46h15.462Zm39.328 0c-1.17 0-2.086-1.129-1.958-2.403.458-4.497 2.507-14.29 11.437-20.17 9.889-6.498 5.076 10.962 3.154 17.083a2.776 2.776 0 0 0 1.15 3.182l.655.415c.824.528.476 1.893-.457 1.893h-13.98Z"
        fill="#32DA6D"
      />
      <path
        d="M20.564 13.062c1.968 0 3.564-1.58 3.564-3.53C24.128 7.58 22.532 6 20.564 6S17 7.581 17 9.531c0 1.95 1.596 3.531 3.564 3.531Zm31.872 0c1.968 0 3.564-1.58 3.564-3.53C56 7.58 54.404 6 52.436 6s-3.564 1.581-3.564 3.531c0 1.95 1.596 3.531 3.564 3.531Zm-7.876 10.13c.884.076 1.551.853 1.329 1.704a9.52 9.52 0 0 1-6.374 6.661 9.658 9.658 0 0 1-3.712.408 9.603 9.603 0 0 1-6.503-3.342 9.433 9.433 0 0 1-2.245-5.86c-.016-.585.51-1.019 1.098-.968l8.47.721 7.937.677Z"
        fill="#092511"
      />
      <path
        d="M91 39.609C91 42.034 88.985 44 86.5 44S82 42.034 82 39.609V5.39C82 2.966 84.015 1 86.5 1S91 2.966 91 5.391V39.61Z"
        fill="currentColor"
      />
      <path
        d="M86.412 44.35c-2.437 0-4.412-1.957-4.412-4.37 0-2.414 1.975-4.37 4.412-4.37h14.207c2.436 0 4.411 1.956 4.411 4.37 0 2.413-1.975 4.37-4.411 4.37H86.412Zm33.436.922c-2.872 0-5.437-.644-7.695-1.934a14.362 14.362 0 0 1-5.284-5.29c-1.263-2.275-1.895-4.872-1.895-7.792 0-2.957.613-5.555 1.838-7.792 1.263-2.275 3.005-4.057 5.226-5.347 2.22-1.289 4.766-1.934 7.637-1.934 3.025 0 5.628.626 7.81 1.877 2.183 1.214 3.867 2.958 5.054 5.233 1.187 2.237 1.78 4.91 1.78 8.02a2.24 2.24 0 0 1-2.24 2.229l-19.661.09c-1.53.007-2.766-1.236-2.733-2.752.03-1.466 1.24-2.638 2.72-2.638h9.057c2.248 0 4.232-2.14 2.52-3.584-1.033-.91-2.45-1.365-4.25-1.365-1.492 0-2.717.285-3.674.853-.92.57-1.608 1.46-2.068 2.674-.46 1.175-.689 2.692-.689 4.55 0 2.654.536 4.626 1.608 5.915 1.11 1.252 2.814 1.877 5.111 1.877 1.685 0 3.082-.284 4.192-.853l.134-.07c1.64-.895 3.275-2.319 5.147-2.319 2.596 0 4.636 2.397 3.204 4.54-.762 1.142-1.753 2.15-2.972 3.025-2.642 1.858-5.934 2.787-9.877 2.787Zm26.5-.183c-3.024 0-5.436-.816-7.236-2.446-1.76-1.669-2.641-3.887-2.641-6.655 0-2.616.9-4.702 2.699-6.256 1.838-1.555 4.48-2.465 7.925-2.73l7.582-.59a.494.494 0 0 0 .458-.491c0-.948-.192-1.726-.576-2.332-.382-.645-.937-1.119-1.664-1.422-.69-.342-1.57-.512-2.642-.512-1.876 0-3.311.341-4.307 1.024-1.547 1.103-2.981 2.957-4.888 2.957h-.223c-2.03 0-3.769-1.682-3.08-3.573a8.935 8.935 0 0 1 1.07-2.058c1.11-1.592 2.68-2.825 4.71-3.697 2.067-.872 4.46-1.308 7.178-1.308 2.795 0 5.149.493 7.063 1.479 1.952.986 3.427 2.427 4.422 4.323 1.033 1.896 1.55 4.209 1.55 6.939v12.45c0 2.296-1.879 4.158-4.2 4.158h-2.931a.785.785 0 0 1-.78-.664c-.123-.804-1.734-1.154-2.393-.669a9.63 9.63 0 0 1-1.353.821c-1.685.835-3.599 1.252-5.743 1.252Zm3.101-6.485c1.685 0 3.062-.398 4.135-1.194 1.071-.834 1.608-2.067 1.608-3.697 0-.825-.715-1.472-1.544-1.399l-2.935.261c-1.915.152-3.274.474-4.078.967-.765.455-1.148 1.138-1.148 2.048 0 1.024.325 1.782.976 2.275.65.493 1.646.74 2.986.74ZM171.781 58c-2.443 0-4.422-1.96-4.422-4.38V20.303c0-2.426 1.986-4.393 4.435-4.393h3.065c.473 0 .873.348.934.813.116.877 1.438 1.213 2.136.661a10.072 10.072 0 0 1 1.95-1.19c1.684-.796 3.54-1.194 5.568-1.194 2.681 0 5.035.588 7.065 1.763 2.028 1.176 3.617 2.863 4.766 5.062 1.148 2.162 1.722 4.778 1.722 7.85 0 2.995-.536 5.668-1.607 8.02-1.034 2.313-2.565 4.133-4.595 5.46-1.99 1.327-4.422 1.99-7.293 1.99-1.99 0-3.828-.34-5.512-1.023-1.42-.576-3.79.49-3.79 2.01v7.63c0 2.34-1.916 4.238-4.28 4.238h-.142Zm4.48-27.87c0 1.403.287 2.654.86 3.754a6.766 6.766 0 0 0 2.47 2.502c1.071.569 2.296.853 3.674.853 1.417 0 2.624-.303 3.619-.91a5.963 5.963 0 0 0 2.354-2.502c.575-1.062.862-2.294.862-3.697s-.287-2.636-.862-3.697a5.962 5.962 0 0 0-2.354-2.503c-.995-.607-2.202-.91-3.619-.91-1.378 0-2.603.303-3.674.91-1.035.569-1.857 1.384-2.47 2.446-.573 1.061-.86 2.313-.86 3.754Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export const LeapText = memo(_LeapText);
LeapText.displayName = "LeapText";

const _Ledger = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <path
      d="M0 206v74.155h112.843V263.71H16.44V206H0Zm283.559 0v57.71h-96.402v16.441H300v-74.15h-16.441ZM113.007 93.155v112.843h74.15v-14.83h-57.709V93.154h-16.441ZM0 19v74.154h16.441V35.441h96.402V19H0Zm187.157 0v16.441h96.402v57.713H300V19H187.157Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export const Ledger = memo(_Ledger);
Ledger.displayName = "Ledger";

const _MetaMask = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 255 236.4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g
      fillRule="nonzero"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round">
      <path stroke="#E2761B" fill="#E2761B" d="m242.3 0-99.5 73.9 18.4-43.6z" />
      <g fill="#E4761B" stroke="#E4761B">
        <path d="m12.6 0 98.7 74.6-17.5-44.3zM206.5 171.3 180 211.9l56.7 15.6 16.3-55.3zM2.1 172.2l16.2 55.3L75 211.9l-26.5-40.6z" />
        <path d="M71.8 102.7 56 126.6l56.3 2.5-2-60.5zM183.1 102.7l-39-34.8-1.3 61.2 56.2-2.5zM75 211.9l33.8-16.5-29.2-22.8zM146.1 195.4l33.9 16.5-4.7-39.3z" />
      </g>
      <g fill="#D7C1B3" stroke="#D7C1B3">
        <path d="m180 211.9-33.9-16.5 2.7 22.1-.3 9.3zM75 211.9l31.5 14.9-.2-9.3 2.5-22.1z" />
      </g>
      <path
        stroke="#233447"
        fill="#233447"
        d="m107 158-28.2-8.3 19.9-9.1zM147.9 158l8.3-17.4 20 9.1z"
      />
      <g fill="#CD6116" stroke="#CD6116">
        <path d="m75 211.9 4.8-40.6-31.3.9zM175.2 171.3l4.8 40.6 26.5-39.7zM199 126.6l-56.2 2.5L148 158l8.3-17.4 20 9.1zM78.8 149.7l20-9.1L107 158l5.3-28.9-56.3-2.5z" />
      </g>
      <g fill="#E4751F" stroke="#E4751F">
        <path d="m56 126.6 23.6 46-.8-22.9zM176.3 149.7l-1 22.9 23.7-46zM112.3 129.1 107 158l6.6 34.1 1.5-44.9zM142.8 129.1l-2.7 18 1.2 45L148 158z" />
      </g>
      <path
        stroke="#F6851B"
        fill="#F6851B"
        d="m148 158-6.7 34.1 4.8 3.3 29.2-22.8 1-22.9zM78.8 149.7l.8 22.9 29.2 22.8 4.8-3.3L107 158z"
      />
      <path
        stroke="#C0AD9E"
        fill="#C0AD9E"
        d="m148.5 226.8.3-9.3-2.5-2.2h-37.7l-2.3 2.2.2 9.3L75 211.9l11 9 22.3 15.5h38.3l22.4-15.5 11-9z"
      />
      <path
        stroke="#161616"
        fill="#161616"
        d="m146.1 195.4-4.8-3.3h-27.7l-4.8 3.3-2.5 22.1 2.3-2.2h37.7l2.5 2.2z"
      />
      <g fill="#763D16" stroke="#763D16">
        <path d="m246.5 78.7 8.5-40.8L242.3 0l-96.2 71.4 37 31.3 52.3 15.3 11.6-13.5-5-3.6 8-7.3-6.2-4.8 8-6.1zM0 37.9l8.5 40.8-5.4 4 8 6.1L5 93.6l8 7.3-5 3.6L19.5 118l52.3-15.3 37-31.3L12.6 0z" />
      </g>
      <path
        stroke="#F6851B"
        fill="#F6851B"
        d="m235.4 118-52.3-15.3 15.9 23.9-23.7 46 31.2-.4H253zM71.8 102.7 19.5 118 2.1 172.2h46.4l31.1.4-23.6-46zM142.8 129.1l3.3-57.7 15.2-41.1H93.8l15 41.1 3.5 57.7 1.2 18.2.1 44.8h27.7l.2-44.8z"
      />
    </g>
  </svg>
);
export const MetaMask = memo(_MetaMask);
MetaMask.displayName = "MetaMask";

const _MetaMaskSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="m285.1 10-.033.024L300 54.668l-10 48.087 6.235 4.714-9.411 7.19 7.294 5.656-9.412 8.604 5.882 4.243-13.647 15.91-.622.167 20.405 63.019.296.006-.14.474.14.433h-.267l-18.9 64.048-66.383-18.245-.242.364-.053-.445-1.41-.001 1.366.663.458-.217-.336.276.336.163-1.26.594-11.644 9.55-26.278 18.225h-44.931l-26.161-18.226-11.643-9.548-1.261-.595.335-.164-.335-.275.457.216 1.294-.63-2.645.001-66.48 18.294L2.252 213.17h-.266l.139-.434-.14-.473.294-.006 20.225-63.019-13.093-16.077 5.882-4.243-9.412-8.604 7.177-5.657-9.412-7.19L10 102.756 0 54.668l14.725-44.372-.391-.296.436.163.054-.163.492.366 94.949 35.396h79.47l-.006.015 95.288-35.746.042-.031.005.014.035-.014ZM167.254 237h-34.76l-6.024 4.157L123.333 269l2.887-2.772h47.31l3.137 2.772-3.389-27.843-6.023-4.157Zm-50.675-62-27.723 13.075L128.143 200l-11.563-25Zm65.053 0-11.871 25 40.476-11.925L181.633 175Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export const MetaMaskSimple = memo(_MetaMaskSimple);
MetaMaskSimple.displayName = "MetaMaskSimple";

const _MetaMaskText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 172 33"
    {...props}>
    <path
      d="M151.256 16.64c-.884-.583-1.858-.998-2.78-1.516-.598-.337-1.235-.635-1.754-1.063-.884-.725-.702-2.15.221-2.772 1.325-.882 3.52-.39 3.754 1.412 0 .039.039.065.078.065h2.001c.052 0 .091-.04.078-.091-.104-1.244-.585-2.28-1.468-2.941-.845-.635-1.806-.972-2.833-.972-5.287 0-5.768 5.585-2.923 7.347.325.207 3.118 1.606 4.106 2.215.987.61 1.299 1.724.87 2.605-.39.803-1.403 1.36-2.416 1.296-1.105-.065-1.962-.661-2.261-1.594a2.82 2.82 0 0 1-.078-.635c0-.039-.039-.078-.078-.078h-2.169c-.039 0-.078.04-.078.078 0 1.568.39 2.436 1.455 3.227 1 .751 2.091 1.062 3.222 1.062 2.962 0 4.495-1.672 4.806-3.408.273-1.697-.233-3.226-1.753-4.237ZM57.057 9.047h-2.014a.088.088 0 0 0-.078.052l-1.78 5.857a.081.081 0 0 1-.155 0l-1.78-5.857c-.013-.04-.04-.052-.078-.052h-3.313c-.039 0-.078.039-.078.078v14.953c0 .039.04.078.078.078h2.17c.039 0 .078-.04.078-.078V12.714c0-.09.13-.104.156-.026l1.792 5.896.13.414c.013.04.04.052.078.052h1.663a.088.088 0 0 0 .078-.052l.13-.414 1.793-5.896c.026-.09.156-.065.156.026v11.364c0 .039.039.078.078.078h2.17c.038 0 .077-.04.077-.078V9.125c0-.04-.039-.078-.078-.078h-1.273ZM118.037 9.047a.088.088 0 0 0-.078.052l-1.779 5.857a.081.081 0 0 1-.156 0l-1.78-5.857c-.013-.04-.039-.052-.078-.052h-3.3c-.039 0-.078.039-.078.078v14.953c0 .039.039.078.078.078h2.17c.039 0 .078-.04.078-.078V12.714c0-.09.13-.104.156-.026l1.792 5.896.13.414c.013.04.039.052.078.052h1.663a.088.088 0 0 0 .078-.052l.13-.414 1.793-5.896c.026-.09.156-.065.156.026v11.364c0 .039.039.078.078.078h2.169c.039 0 .078-.04.078-.078V9.125c0-.04-.039-.078-.078-.078h-3.3ZM90.054 9.047h-10.25c-.039 0-.078.039-.078.078v1.866c0 .038.04.077.078.077h3.963v13.01c0 .039.038.078.078.078h2.169c.039 0 .078-.04.078-.078v-13.01h3.962a.084.084 0 0 0 .078-.077V9.125c0-.04-.026-.078-.078-.078ZM102.851 24.155h1.974c.052 0 .091-.051.078-.103l-4.079-15.005c-.013-.04-.039-.052-.078-.052h-2.832a.088.088 0 0 0-.078.052l-4.08 15.005c-.012.052.027.103.079.103h1.975a.088.088 0 0 0 .078-.051l1.182-4.367c.013-.039.039-.052.078-.052h4.365c.039 0 .065.026.078.052l1.182 4.367c.013.026.052.051.078.051Zm-5.184-6.608 1.585-5.844a.081.081 0 0 1 .156 0l1.585 5.844c.013.052-.026.104-.078.104h-3.17c-.052 0-.09-.052-.078-.104ZM136.524 24.155h1.974c.052 0 .091-.051.078-.103l-4.079-15.005c-.013-.04-.039-.052-.078-.052h-2.832a.088.088 0 0 0-.078.052l-4.079 15.005c-.013.052.026.103.078.103h1.975a.088.088 0 0 0 .078-.051l1.182-4.367c.013-.039.039-.052.078-.052h4.365c.039 0 .065.026.078.052l1.182 4.367a.088.088 0 0 0 .078.051Zm-5.184-6.608 1.585-5.844a.081.081 0 0 1 .156 0l1.585 5.844c.013.052-.026.104-.078.104h-3.17c-.052 0-.091-.052-.078-.104ZM67.216 21.94V17.3c0-.038.039-.077.078-.077h5.781c.039 0 .078-.039.078-.078V15.28c0-.04-.039-.078-.078-.078h-5.781c-.039 0-.078-.04-.078-.078v-3.965c0-.039.039-.078.078-.078h6.574c.038 0 .078-.039.078-.077V9.138c0-.04-.04-.078-.078-.078H64.969c-.04 0-.078.039-.078.078v14.94c0 .039.039.078.078.078h9.171c.04 0 .078-.04.078-.078v-1.97c0-.039-.039-.078-.078-.078h-6.859c-.039-.012-.065-.038-.065-.09ZM171.08 24.026l-7.509-7.736a.079.079 0 0 1 0-.103l6.756-6.998a.075.075 0 0 0-.052-.13h-2.767c-.026 0-.039.014-.052.027l-5.729 5.934a.075.075 0 0 1-.13-.051V9.137c0-.04-.039-.078-.078-.078h-2.17c-.039 0-.078.039-.078.078V24.09c0 .039.039.078.078.078h2.17c.039 0 .078-.04.078-.078v-6.583c0-.064.091-.103.13-.052l6.495 6.687a.099.099 0 0 0 .052.026h2.767c.052-.013.091-.104.039-.143Z"
      fill="#fff"
    />
    <path
      d="m32.958 1-13.134 9.718 2.443-5.727L32.958 1Z"
      fill="#E17726"
      stroke="#E17726"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m2.663 1 13.017 9.809-2.325-5.818L2.663 1ZM28.23 23.533l-3.495 5.339 7.483 2.06 2.143-7.282-6.132-.117ZM1.273 23.65l2.13 7.282 7.47-2.06-3.481-5.339-6.12.117Z"
      fill="#E27625"
      stroke="#E27625"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.47 14.515 8.392 17.65l7.405.337-.247-7.97-5.08 4.497ZM25.15 14.515l-5.157-4.587-.169 8.06 7.405-.337-2.079-3.136ZM10.873 28.872l4.482-2.164-3.858-3.006-.624 5.17ZM20.266 26.708l4.469 2.164-.61-5.17-3.86 3.006Z"
      fill="#E27625"
      stroke="#E27625"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m24.735 28.872-4.47-2.164.365 2.903-.04 1.23 4.145-1.969ZM10.873 28.872l4.158 1.97-.027-1.231.351-2.903-4.482 2.164Z"
      fill="#D5BFB2"
      stroke="#D5BFB2"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m15.108 21.784-3.715-1.088 2.624-1.205 1.091 2.293ZM20.513 21.784l1.091-2.293 2.637 1.205-3.728 1.088Z"
      fill="#233447"
      stroke="#233447"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m10.873 28.872.65-5.339-4.131.117 3.481 5.222ZM24.098 23.533l.637 5.339 3.494-5.222-4.13-.117ZM27.229 17.65l-7.405.338.688 3.796 1.092-2.293 2.637 1.205 2.988-3.045ZM11.393 20.696l2.624-1.205 1.091 2.293.689-3.796-7.405-.337 3 3.045Z"
      fill="#CC6228"
      stroke="#CC6228"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m8.392 17.65 3.105 6.052-.104-3.006-3-3.045ZM24.241 20.696l-.117 3.006 3.105-6.051-2.988 3.045ZM15.797 17.988l-.688 3.796.87 4.483.195-5.908-.377-2.372ZM19.824 17.988l-.364 2.358.182 5.921.87-4.483-.688-3.796Z"
      fill="#E27525"
      stroke="#E27525"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m20.513 21.784-.87 4.484.623.44 3.858-3.006.117-3.006-3.728 1.088ZM11.393 20.696l.104 3.006 3.858 3.006.624-.44-.87-4.484-3.716-1.088Z"
      fill="#F5841F"
      stroke="#F5841F"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m20.59 30.842.04-1.231-.338-.285h-4.963l-.325.285.027 1.23-4.158-1.969 1.455 1.192 2.95 2.035h5.053l2.962-2.035 1.442-1.192-4.144 1.97Z"
      fill="#C0AC9D"
      stroke="#C0AC9D"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m20.266 26.708-.624-.44H15.98l-.624.44-.35 2.903.324-.285h4.963l.338.285-.364-2.903Z"
      fill="#161616"
      stroke="#161616"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.517 11.353 34.62 5.99 32.958 1l-12.692 9.394 4.885 4.12 6.898 2.01 1.52-1.776-.663-.48 1.053-.958-.806-.622 1.052-.804-.688-.53ZM1 5.989l1.117 5.364-.714.531 1.065.804-.805.622 1.052.959-.663.48 1.52 1.774 6.899-2.008 4.884-4.12L2.663 1 1 5.989Z"
      fill="#763E1A"
      stroke="#763E1A"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m32.049 16.523-6.898-2.008 2.078 3.136-3.105 6.05 4.106-.05h6.131l-2.312-7.128ZM10.47 14.515l-6.898 2.008-2.3 7.127h6.12l4.105.052-3.105-6.051 2.078-3.136ZM19.824 17.988l.442-7.594 2-5.403h-8.911l2 5.403.442 7.594.169 2.384.013 5.896h3.663l.013-5.896.17-2.384Z"
      fill="#F5841F"
      stroke="#F5841F"
      strokeWidth=".25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MetaMaskText = memo(_MetaMaskText);
MetaMaskText.displayName = "MetaMaskText";

const _OKX = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <path
      d="M0 54v192c0 29.823 24.177 54 54 54h192c29.823 0 54-24.177 54-54V54c0-29.823-24.177-54-54-54H54C24.177 0 0 24.177 0 54Zm64.898 15.302a3.831 3.831 0 0 1 3.823-3.824h49.12a3.831 3.831 0 0 1 3.824 3.824v49.12c0 2.13-1.718 3.848-3.823 3.848H68.72c-2.105 0-3.823-1.718-3.823-3.848v-49.12Zm56.767 161.397a3.831 3.831 0 0 1-3.823 3.823H68.72a3.831 3.831 0 0 1-3.823-3.823v-49.121c0-2.13 1.718-3.848 3.823-3.848h49.12c2.106 0 3.824 1.718 3.824 3.848v49.12Zm52.895-52.315h-49.12a3.857 3.857 0 0 1-3.848-3.848v-49.12a3.857 3.857 0 0 1 3.848-3.848h49.12a3.857 3.857 0 0 1 3.848 3.847v49.121a3.857 3.857 0 0 1-3.848 3.848Zm60.615 52.315c0 2.105-1.718 3.823-3.847 3.823h-49.121a3.831 3.831 0 0 1-3.823-3.823v-49.121c0-2.13 1.718-3.848 3.823-3.848h49.12a3.857 3.857 0 0 1 3.848 3.848v49.12Zm0-112.3a3.842 3.842 0 0 1-3.847 3.847h-49.121c-2.105 0-3.823-1.718-3.823-3.848v-49.12a3.831 3.831 0 0 1 3.823-3.824h49.12c2.106 0 3.848 1.718 3.848 3.823v49.121Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export const OKX = memo(_OKX);
OKX.displayName = "OKX";

const _OKXText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 746.741 223.999"
    {...props}>
    <path
      d="M219.016 0H4.977A4.974 4.974 0 0 0 0 4.978v214.039c0 1.32.524 2.586 1.458 3.519a4.973 4.973 0 0 0 3.519 1.458h214.039a4.974 4.974 0 0 0 4.978-4.977V4.978A4.974 4.974 0 0 0 219.016 0Zm-69.687 144.352a4.977 4.977 0 0 1-4.977 4.978h-64.71a4.982 4.982 0 0 1-3.52-1.458 4.98 4.98 0 0 1-1.457-3.52v-64.71a4.977 4.977 0 0 1 4.977-4.977h64.71c1.32 0 2.586.524 3.519 1.458a4.973 4.973 0 0 1 1.458 3.519v64.71Zm517.8-69.679H602.42a4.977 4.977 0 0 0-4.978 4.977v64.71a4.978 4.978 0 0 0 4.978 4.978h64.709a4.978 4.978 0 0 0 4.978-4.978V79.65a4.977 4.977 0 0 0-4.978-4.977ZM592.434.006h-64.709a4.978 4.978 0 0 0-4.978 4.978v64.709a4.978 4.978 0 0 0 4.978 4.978h64.709a4.978 4.978 0 0 0 4.978-4.978V4.984a4.977 4.977 0 0 0-4.978-4.978Zm149.33 0h-64.71a4.978 4.978 0 0 0-4.978 4.978v64.709a4.978 4.978 0 0 0 4.978 4.978h64.71a4.977 4.977 0 0 0 4.977-4.978V4.984a4.977 4.977 0 0 0-4.977-4.978Zm-149.33 149.328h-64.709a4.977 4.977 0 0 0-4.978 4.977v64.71a4.978 4.978 0 0 0 4.978 4.978h64.709a4.978 4.978 0 0 0 4.978-4.978v-64.71a4.977 4.977 0 0 0-4.978-4.977Zm149.33 0h-64.71a4.977 4.977 0 0 0-4.978 4.977v64.71a4.978 4.978 0 0 0 4.978 4.978h64.71a4.977 4.977 0 0 0 4.977-4.978v-64.71a4.977 4.977 0 0 0-4.977-4.977ZM480.343.006h-64.709a4.978 4.978 0 0 0-4.978 4.978v64.709a4.978 4.978 0 0 0 4.978 4.978h64.709a4.978 4.978 0 0 0 4.978-4.978V4.984a4.978 4.978 0 0 0-4.978-4.978Zm0 149.328h-64.709a4.977 4.977 0 0 0-4.978 4.977v64.71a4.978 4.978 0 0 0 4.978 4.978h64.709a4.978 4.978 0 0 0 4.978-4.978v-64.71a4.977 4.977 0 0 0-4.978-4.977Zm-69.687-69.748a4.978 4.978 0 0 0-4.978-4.977h-69.687V4.978A4.978 4.978 0 0 0 331.013 0h-64.709a4.974 4.974 0 0 0-4.978 4.978v213.927a4.974 4.974 0 0 0 4.978 4.977h64.709a4.977 4.977 0 0 0 4.978-4.977v-69.631h69.687a4.982 4.982 0 0 0 4.978-4.978v-64.71Z"
      fill="currentColor"
    />
  </svg>
);
export const OKXText = memo(_OKXText);
OKXText.displayName = "OKXText";

const _Rabby = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <defs>
      <linearGradient
        x1="29.507%"
        y1="48.506%"
        x2="99.232%"
        y2="65.661%"
        id="rabby_a">
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#FFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="139.975%"
        y1="96.112%"
        x2="-13.351%"
        y2="11.927%"
        id="rabby_b">
        <stop stopColor="#8697FF" offset="0%" />
        <stop stopColor="#8697FF" stopOpacity="0" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="102.916%"
        y1="72.633%"
        x2="-.701%"
        y2="24.313%"
        id="rabby_c">
        <stop stopColor="#8697FF" offset="0%" />
        <stop stopColor="#8697FF" stopOpacity="0" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="39.278%"
        y1="34.639%"
        x2="93.491%"
        y2="76.624%"
        id="rabby_d">
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#D1D8FF" offset="98.389%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M298.467 157.922C310.25 129.923 251.999 51.7 196.349 19.11 161.27-6.138 124.72-2.67 117.317 8.415c-16.245 24.328 53.795 44.943 100.637 68.998-10.068 4.652-19.558 13-25.138 23.676-17.462-20.28-55.791-37.743-100.767-23.676-30.308 9.48-55.496 31.828-65.23 65.582a18.054 18.054 0 0 0-7.74-1.74C8.541 141.256 0 150.343 0 161.55c0 11.208 8.542 20.293 19.078 20.293 1.953 0 8.06-1.393 8.06-1.393l97.582.752c-39.025 65.853-69.866 75.48-69.866 86.888 0 11.409 29.51 8.317 40.589 4.065 53.042-20.358 110.012-83.804 119.787-102.067 41.053 5.447 75.554 6.092 83.237-12.165Z"
        fill="url(#rabby_a)"
        fillRule="nonzero"
        transform="translate(0 12)"
      />
      <path
        d="M218.307 76.997a.304.304 0 0 0 .008.003c2.182-.905 1.829-4.3 1.23-6.965-1.378-6.126-25.137-30.839-47.448-41.907C141.696 13.046 119.31 13.823 116 20.773c6.191 13.37 34.902 25.921 64.889 39.031 12.793 5.593 25.817 11.287 37.424 17.19l-.006.003Z"
        fill="url(#rabby_b)"
        transform="translate(0 12)"
      />
      <path
        d="M180 212.561c-6.128-2.492-13.05-4.777-20.921-6.85 8.391-15.972 10.152-39.616 2.227-54.565-11.123-20.98-25.085-32.146-57.53-32.146-17.845 0-65.89 6.393-66.743 49.053-.09 4.475-.002 8.578.303 12.35l87.734.676c-11.828 19.958-22.905 34.76-32.603 46.016a6691.06 6691.06 0 0 1 30.075 8.283c8.37 2.321 16.032 4.446 24.05 6.622 12.098-9.374 23.47-19.596 33.408-29.439Z"
        fill="url(#rabby_c)"
        transform="translate(0 12)"
      />
      <path
        d="M25.453 176.36c3.583 32.332 20.893 45.003 56.264 48.752 35.372 3.75 55.66 1.235 82.673 3.843 22.56 2.18 42.705 14.383 50.177 10.166 6.726-3.796 2.963-17.508-6.037-26.305-11.664-11.404-27.809-19.333-56.217-22.146 5.662-16.454 4.075-39.525-4.718-52.076-12.713-18.15-36.179-26.355-65.878-22.77-31.029 3.746-60.76 19.961-56.264 60.537Z"
        fill="url(#rabby_d)"
        fillRule="nonzero"
        transform="translate(0 12)"
      />
    </g>
  </svg>
);
export const Rabby = memo(_Rabby);
Rabby.displayName = "Rabby";

const _RabbySimple = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <path
      d="M117.317 20.415C124.72 9.33 161.271 5.862 196.35 31.11c55.65 32.59 113.901 110.814 102.118 138.813-7.683 18.257-42.184 17.612-83.237 12.165l-.295.54c-3.497 6.262-12 17.275-23.714 29.943 6.9 3.411 12.488 7.532 17.31 12.246l.533.533c8.612 8.808 12.094 22.052 5.503 25.772-7.472 4.217-27.617-7.986-50.177-10.166a249.57 249.57 0 0 0-1.798-.167 344.314 344.314 0 0 1-16 13.212l-.264-.072c-16.223 12.587-33.759 23.653-50.885 30.226-11.08 4.252-40.59 7.344-40.59-4.065 0-8.057 15.383-15.225 38.167-41.938-3.599-.28-7.357-.62-11.303-1.039-33.746-3.577-51.052-15.275-55.683-44.418l-1.165.245c-1.946.4-4.618.903-5.79.903C8.541 193.842 0 184.757 0 173.55c0-11.207 8.542-20.293 19.078-20.293 2.756 0 5.375.621 7.74 1.739 9.735-33.754 34.923-56.102 65.231-65.582 44.976-14.067 83.305 3.396 100.767 23.676 5.58-10.676 15.07-19.024 25.138-23.676-8.431-4.33-17.614-8.548-26.91-12.697l-3.103-1.38-13.124-5.804c-24.319-10.775-46.835-21.234-55.8-32.143l-.185-.232c-1.197-1.453-2.151-2.914-2.832-4.384l.042-.087c-1.761-4.004-1.522-8.082 1.275-12.27Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export const RabbySimple = memo(_RabbySimple);
RabbySimple.displayName = "RabbySimple";

const _RabbyText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 152 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#rabbytext_a)">
      <path
        d="M46.261 15.224h.59c.617 0 1.09-.14 1.419-.42.33-.28.494-.683.494-1.208 0-.525-.165-.928-.494-1.208-.33-.28-.803-.42-1.419-.42h-.59v3.256Zm6.87 7.299h-3.889l-2.98-5.076v5.076h-3.125V9.325H48c.67 0 1.254.111 1.753.333.5.21.909.502 1.228.875.329.373.573.805.733 1.295.17.49.255 1.015.255 1.575 0 1.004-.223 1.82-.67 2.45-.435.62-1.084 1.04-1.944 1.261l3.777 5.409ZM55.702 18.007c0 .291.048.566.143.822.096.245.224.461.383.648.17.187.367.333.59.438.233.105.483.157.749.157.255 0 .494-.052.717-.157.234-.105.43-.251.59-.438.17-.187.303-.402.398-.648.107-.245.16-.507.16-.787s-.053-.543-.16-.788a2.028 2.028 0 0 0-.398-.665 1.655 1.655 0 0 0-.59-.438 1.662 1.662 0 0 0-.717-.157c-.266 0-.516.052-.75.157-.222.105-.419.251-.589.438-.16.187-.287.403-.383.648-.095.233-.143.49-.143.77Zm3.634-4.464h2.901v8.98h-2.9v-.998c-.617.852-1.451 1.278-2.503 1.278a3.83 3.83 0 0 1-1.642-.35 4.09 4.09 0 0 1-1.307-1.015 4.852 4.852 0 0 1-.877-1.523 5.799 5.799 0 0 1-.303-1.908c0-.642.101-1.249.303-1.82a4.783 4.783 0 0 1 .845-1.523c.361-.432.792-.77 1.291-1.015a3.572 3.572 0 0 1 1.658-.386c1.02 0 1.865.391 2.534 1.173v-.893ZM69.764 18.06c0-.28-.048-.543-.144-.788a2.026 2.026 0 0 0-.398-.665 1.866 1.866 0 0 0-.59-.438 1.558 1.558 0 0 0-.733-.175c-.255 0-.495.052-.718.157-.223.105-.42.251-.59.438-.159.187-.292.409-.398.665a2.148 2.148 0 0 0-.143.788c0 .28.047.542.143.787.096.245.229.461.399.648.17.175.366.321.59.438.233.105.478.157.733.157s.494-.052.717-.157c.223-.105.414-.251.574-.438a2.07 2.07 0 0 0 .398-.648c.106-.245.16-.501.16-.77ZM66.129 7.994v6.441c.68-.782 1.53-1.173 2.55-1.173.606 0 1.159.129 1.658.386.51.245.94.583 1.292 1.015.36.42.642.921.844 1.505a5.48 5.48 0 0 1 .303 1.838c0 .665-.106 1.29-.319 1.873a4.622 4.622 0 0 1-.86 1.523 4.255 4.255 0 0 1-1.323 1.032c-.5.245-1.042.368-1.626.368-1.063 0-1.902-.426-2.519-1.278v.998h-2.885V7.995h2.885ZM79.984 18.06c0-.28-.048-.543-.144-.788a2.029 2.029 0 0 0-.398-.665 1.865 1.865 0 0 0-.59-.438 1.558 1.558 0 0 0-.733-.175c-.255 0-.494.052-.718.157-.223.105-.42.251-.59.438-.159.187-.292.409-.398.665a2.148 2.148 0 0 0-.143.788c0 .28.048.542.143.787.096.245.229.461.399.648.17.175.366.321.59.438.233.105.478.157.733.157s.494-.052.717-.157c.223-.105.414-.251.574-.438.17-.187.303-.402.398-.648.107-.245.16-.501.16-.77ZM76.35 7.994v6.441c.68-.782 1.53-1.173 2.55-1.173.605 0 1.158.129 1.658.386.51.245.94.583 1.29 1.015.362.42.644.921.846 1.505a5.48 5.48 0 0 1 .302 1.838c0 .665-.106 1.29-.318 1.873a4.624 4.624 0 0 1-.861 1.523 4.253 4.253 0 0 1-1.323 1.032c-.5.245-1.042.368-1.626.368-1.063 0-1.902-.426-2.518-1.278v.998h-2.886V7.995h2.886Z"
        fill="#fff"
      />
      <path
        d="m86.213 21.297-3.953-7.754h3.348l2.183 4.604 2.12-4.603h3.316l-6.567 13.46h-3.236l2.79-5.707ZM100.006 9.325l2.073 8.524 2.55-8.524h2.487l2.55 8.524 2.072-8.524h3.268l-3.587 13.198h-3.188l-2.359-7.65-2.359 7.65h-3.188L96.739 9.325h3.267ZM117.178 18.007c0 .291.048.566.144.822.096.245.223.461.382.648.17.187.367.333.59.438.234.105.484.157.749.157.255 0 .495-.052.718-.157.233-.105.43-.251.589-.438.17-.187.303-.402.399-.648.106-.245.159-.507.159-.787s-.053-.543-.159-.788a2.034 2.034 0 0 0-.399-.665 1.656 1.656 0 0 0-.589-.438 1.665 1.665 0 0 0-.718-.157c-.265 0-.515.052-.749.157-.223.105-.42.251-.59.438a2.26 2.26 0 0 0-.382.648c-.096.233-.144.49-.144.77Zm3.635-4.464h2.901v8.98h-2.901v-.998c-.617.852-1.451 1.278-2.503 1.278a3.832 3.832 0 0 1-1.642-.35 4.095 4.095 0 0 1-1.307-1.015 4.839 4.839 0 0 1-.876-1.523 5.796 5.796 0 0 1-.303-1.908c0-.642.101-1.249.303-1.82a4.789 4.789 0 0 1 .844-1.523 3.92 3.92 0 0 1 1.292-1.015 3.57 3.57 0 0 1 1.657-.386c1.02 0 1.865.391 2.535 1.173v-.893ZM127.606 7.995v14.528h-2.885V7.995h2.885ZM131.506 7.995v14.528h-2.885V7.995h2.885ZM138.499 16.73c-.096-.444-.293-.8-.59-1.069a1.562 1.562 0 0 0-1.084-.402c-.446 0-.813.128-1.1.385-.276.257-.452.618-.526 1.085h3.3Zm-3.38 1.837c0 1.365.585 2.048 1.754 2.048.627 0 1.1-.28 1.418-.84h2.79c-.563 2.053-1.971 3.08-4.224 3.08-.691 0-1.323-.11-1.897-.332a4.358 4.358 0 0 1-1.482-.98 4.419 4.419 0 0 1-.941-1.506c-.223-.583-.335-1.237-.335-1.96 0-.747.107-1.418.319-2.013a4.31 4.31 0 0 1 .909-1.54c.393-.42.866-.741 1.418-.963.564-.233 1.196-.35 1.897-.35.691 0 1.313.117 1.865.35.553.222 1.02.548 1.403.98.382.432.675.963.877 1.593.202.618.302 1.319.302 2.1v.333h-6.073ZM145.214 16.186v6.337h-2.885v-6.337h-.956v-2.643h.956v-2.695h2.885v2.695h1.642v2.643h-1.642Z"
        fill="#fff"
      />
      <path
        d="M35.115 18.55C36.5 15.263 29.648 6.074 23.1 2.246 18.974-.721 14.674-.314 13.803.989c-1.91 2.857 6.33 5.279 11.84 8.105-1.184.546-2.3 1.527-2.957 2.78-2.055-2.382-6.564-4.433-11.855-2.78-3.566 1.113-6.53 3.738-7.675 7.703a2.127 2.127 0 0 0-.91-.204C1.005 16.593 0 17.66 0 18.977c0 1.316 1.005 2.384 2.245 2.384.23 0 .948-.164.948-.164l11.48.088c-4.591 7.736-8.22 8.867-8.22 10.207 0 1.34 3.472.977 4.776.477 6.24-2.391 12.943-9.844 14.093-11.99 4.83.64 8.889.716 9.793-1.428Z"
        fill="url(#rabbytext_b)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.642 9.094c.256-.107.215-.507.144-.822-.16-.723-2.943-3.64-5.555-4.947-3.559-1.78-6.18-1.688-6.567-.868.725 1.578 4.086 3.06 7.597 4.607 1.498.66 3.022 1.333 4.381 2.03Z"
        fill="url(#rabbytext_c)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.125 24.977c-.72-.292-1.533-.56-2.457-.803.985-1.873 1.192-4.646.261-6.4-1.306-2.46-2.946-3.77-6.757-3.77-2.096 0-7.74.75-7.84 5.753-.01.525 0 1.006.036 1.449l10.305.079c-1.39 2.34-2.69 4.077-3.83 5.397 1.368.372 2.497.684 3.533.971.983.272 1.883.522 2.825.777a43.625 43.625 0 0 0 3.924-3.453Z"
        fill="url(#rabbytext_d)"
      />
      <path
        d="M3.018 20.692c.42 3.8 2.454 5.29 6.61 5.73 4.156.442 6.54.146 9.714.453 2.65.256 5.017 1.69 5.895 1.195.79-.447.348-2.059-.71-3.093-1.37-1.34-3.267-2.272-6.604-2.603.665-1.934.479-4.646-.554-6.122-1.494-2.133-4.251-3.098-7.74-2.676-3.646.44-7.14 2.346-6.611 7.116Z"
        fill="url(#rabbytext_e)"
      />
    </g>
    <defs>
      <linearGradient
        id="rabbytext_b"
        x1="10.414"
        y1="15.638"
        x2="35.024"
        y2="22.209"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="rabbytext_c"
        x1="30.707"
        y1="15.146"
        x2="12.039"
        y2="-2.475"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#8697FF" />
        <stop offset="1" stopColor="#8697FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="rabbytext_d"
        x1="21.615"
        y1="25.63"
        x2="4.211"
        y2="16.209"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#8697FF" />
        <stop offset="1" stopColor="#8697FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="rabbytext_e"
        x1="11.871"
        y1="15.445"
        x2="24.165"
        y2="30.152"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset=".984" stopColor="#D1D8FF" />
      </linearGradient>
      <clipPath id="rabbytext_a">
        <path fill="#fff" d="M0 0h152v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const RabbyText = memo(_RabbyText);
RabbyText.displayName = "RabbyText";

const _Station = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <defs>
      <linearGradient
        x1="97.12%"
        y1="12.295%"
        x2="15.952%"
        y2="88.858%"
        id="station_a">
        <stop stopColor="#D615EB" offset="0%" />
        <stop stopColor="#8436F5" offset="100%" />
      </linearGradient>
    </defs>
    <g fillRule="nonzero" fill="none">
      <rect fill="url(#station_a)" width="300" height="300" rx="30" />
      <path
        d="m69.837 193.58 47.635 25.43L87.15 249.98a1.403 1.403 0 0 1-1.643.405h-.133l-45.537-23.279a1.588 1.588 0 0 1-.512-2.362l30.512-31.165Zm39.895-39.76.22.076 45.567 23.287a1.48 1.48 0 0 1 .756 1.876l-.112.223a.941.941 0 0 1-.186.298l-35.242 36.234-47.723-25.465 35.297-36.05a1.4 1.4 0 0 1 1.423-.478Zm29.131-57.94.87.4 18.946 9.516 55.868 28.273c9.983 5.09 15.299 15.994 15.22 28.16l-.013.715 9.983 4.8-.052.102c.112.05.224.104.334.16 6.07 3.066 7.009 13.125 2.257 22.54-4.753 9.413-13.427 14.551-19.494 11.485a8.062 8.062 0 0 1-1.447-.937l-8.912-4.508c-9.504 7.575-21.468 9.963-31.54 5.232l-.754-.37-26.455-13.363 9.11-9.366c.062-.067.115-.142.159-.222l.058-.125.13-.259a1.724 1.724 0 0 0-.881-2.185l-53.08-27.127-.256-.085a1.625 1.625 0 0 0-1.658.555l-9.08 9.274a26.52 26.52 0 0 1-5.388-8.228c-.898-2.445-1.95-6.195-2.347-8.69-5.672-6.779-6.32-18.212-1.102-28.542 4.867-9.416 13.958-15.98 22.725-15.98h.996l.698-.349c2.053-1.058 5.11-1.713 7.333-2.336l-.027-.01a27.368 27.368 0 0 1 17.799 1.47Zm97.73 78.89c-3.655-1.85-8.88 1.262-11.745 6.917-2.863 5.674-2.297 11.733 1.36 13.582 3.656 1.847 8.881-1.249 11.745-6.92 2.863-5.672 2.297-11.733-1.358-13.58ZM91.9 80.092l.63.304 25.444 13.023c-1.97-.485-4.092-.772-5.857-.753-10.191 0-20.842 6.995-26.488 18.428-6.609 12.981-4.576 28.637 3.756 36.741L65.109 135.44a.723.723 0 0 0-.342-.227l-.09-.016c-12.326-6.208-16.014-23.65-8.34-38.673C63.875 81.752 79.658 74.439 91.9 80.093Zm86.277 5.65 47.555 25.453-16.552 16.57-48.36-24.563 17.357-17.46Zm36.002-36.238.223.035.222.074L260.387 72.9a1.61 1.61 0 0 1 .777 2.098 1.13 1.13 0 0 1-.16.265l-32.086 32.714-47.646-25.414 31.71-32.547c.291-.357.739-.549 1.197-.511Z"
        fill="#FFF"
      />
    </g>
  </svg>
);
export const Station = memo(_Station);
Station.displayName = "Station";

type CustomProps = SVGProps<SVGSVGElement> & {
  gradient?: boolean;
};

const _StationSimple = ({ gradient, ...props }: CustomProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" {...props}>
    <defs>
      <linearGradient
        x1="97.12%"
        y1="19.187%"
        x2="15.952%"
        y2="81.755%"
        id="station_c">
        <stop stopColor="#D615EB" offset="0%" />
        <stop stopColor="#8436F5" offset="100%" />
      </linearGradient>
    </defs>
    <path
      d="M138.717 696v.01L353 810.37 216.599 949.667a6.311 6.311 0 0 1-7.39 1.82h-.6L3.767 846.79a7.137 7.137 0 0 1-2.303-10.623L138.717 696ZM318.18 517.183v.01l.99.33L524.15 622.257a6.656 6.656 0 0 1 3.4 8.436l-.5 1c-.193.497-.478.952-.84 1.342L367.68 796 153 681.47l158.78-162.135a6.3 6.3 0 0 1 6.401-2.152Zm131.045-260.59 3.913 1.799 85.227 42.799 251.32 127.16c44.906 22.887 68.82 71.93 68.469 126.649l-.06 3.217L903 579.807l-.232.458c.504.227 1.006.466 1.503.717h.01c27.295 13.788 31.518 59.032 10.143 101.377-21.385 42.334-60.4 65.44-87.695 51.653a36.269 36.269 0 0 1-6.504-4.214l-40.094-20.275c-42.754 34.068-96.574 44.807-141.879 23.528l-3.392-1.659-119.009-60.102 40.978-42.124c.362-.39.657-.834.876-1.317l.103-.245.583-1.166a7.753 7.753 0 0 0-3.962-9.826L315.655 494.61l-1.154-.385v-.012a7.338 7.338 0 0 0-7.456 2.506l-40.848 41.71a119.276 119.276 0 0 1-24.26-37.06c-4.035-11.008-8.755-27.83-10.533-39.023-25.517-30.49-28.427-81.91-4.96-128.37 21.898-42.35 62.793-71.87 102.229-71.87h4.479l3.14-1.57c9.239-4.76 22.99-7.706 32.99-10.506a70.699 70.699 0 0 0-.132-.054 123.17 123.17 0 0 1 80.076 6.617ZM888.86 611.4c-16.445-8.313-39.951 5.68-52.835 31.114-12.878 25.518-10.334 52.77 6.117 61.084 16.445 8.307 39.95-5.614 52.835-31.12 12.878-25.512 10.334-52.77-6.111-61.078Zm-650.89-425.808 2.83 1.368 114.452 58.571c-8.858-2.18-18.405-3.47-26.339-3.385-45.844 0-93.759 31.46-119.156 82.88-29.73 58.385-20.581 128.804 16.904 165.25l-109.209-55.76a3.252 3.252 0 0 0-1.54-1.02l-.401-.07c-55.451-27.923-72.04-106.369-37.521-173.934h-.01c33.919-66.437 104.919-99.326 159.99-73.9Zm388.107 25.416L840 325.477 765.542 400 548 289.528l78.076-78.521ZM788.032 48.02l.999.16.999.33 205.862 104.732a7.24 7.24 0 0 1 3.497 9.437 5.085 5.085 0 0 1-.72 1.19L854.334 311 640 196.702l142.646-146.38a6.29 6.29 0 0 1 5.386-2.302Z"
      fill={gradient ? "url(#station_c)" : "currentColor"}
      fillRule="nonzero"
    />
  </svg>
);
export const StationSimple = memo(_StationSimple);
StationSimple.displayName = "StationSimple";

const _StationText = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 907.88 300" {...props}>
    <defs>
      <linearGradient
        x1="97.12%"
        y1="12.295%"
        x2="15.952%"
        y2="88.858%"
        id="station_b">
        <stop stopColor="#D615EB" offset="0%" />
        <stop stopColor="#8436F5" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="nonzero">
      <rect fill="url(#station_b)" width="300" height="300" rx="30" />
      <path
        d="m69.837 193.58 47.635 25.43L87.15 249.98a1.403 1.403 0 0 1-1.643.405h-.133l-45.537-23.279a1.588 1.588 0 0 1-.512-2.362l30.512-31.165Zm39.895-39.76.22.076 45.567 23.287a1.48 1.48 0 0 1 .756 1.876l-.112.223a.941.941 0 0 1-.186.298l-35.242 36.234-47.723-25.465 35.297-36.05a1.4 1.4 0 0 1 1.423-.478Zm29.131-57.94.87.4 18.946 9.516 55.868 28.273c9.983 5.09 15.299 15.994 15.22 28.16l-.013.715 9.983 4.8-.052.102c.112.05.224.104.334.16 6.07 3.066 7.009 13.125 2.257 22.54-4.753 9.413-13.427 14.551-19.494 11.485a8.062 8.062 0 0 1-1.447-.937l-8.912-4.508c-9.504 7.575-21.468 9.963-31.54 5.232l-.754-.37-26.455-13.363 9.11-9.366c.062-.067.115-.142.159-.222l.058-.125.13-.259a1.724 1.724 0 0 0-.881-2.185l-53.08-27.127-.256-.085a1.625 1.625 0 0 0-1.658.555l-9.08 9.274a26.52 26.52 0 0 1-5.388-8.228c-.898-2.445-1.95-6.195-2.347-8.69-5.672-6.779-6.32-18.212-1.102-28.542 4.867-9.416 13.958-15.98 22.725-15.98h.996l.698-.349c2.053-1.058 5.11-1.713 7.333-2.336l-.027-.01a27.368 27.368 0 0 1 17.799 1.47Zm97.73 78.89c-3.655-1.85-8.88 1.262-11.745 6.917-2.863 5.674-2.297 11.733 1.36 13.582 3.656 1.847 8.881-1.249 11.745-6.92 2.863-5.672 2.297-11.733-1.358-13.58ZM91.9 80.092l.63.304 25.444 13.023c-1.97-.485-4.092-.772-5.857-.753-10.191 0-20.842 6.995-26.488 18.428-6.609 12.981-4.576 28.637 3.756 36.741L65.109 135.44a.723.723 0 0 0-.342-.227l-.09-.016c-12.326-6.208-16.014-23.65-8.34-38.673C63.875 81.752 79.658 74.439 91.9 80.093Zm86.277 5.65 47.555 25.453-16.552 16.57-48.36-24.563 17.357-17.46Zm36.002-36.238.223.035.222.074L260.387 72.9a1.61 1.61 0 0 1 .777 2.098 1.13 1.13 0 0 1-.16.265l-32.086 32.714-47.646-25.414 31.71-32.547c.291-.357.739-.549 1.197-.511Z"
        fill="#FFF"
      />
      <g fill="#FFF">
        <path d="M421.68 218.04c-20.173 0-36.267-6.007-48.28-18.02l13.26-18.87c9.86 10.313 21.873 15.47 36.04 15.47 6.347 0 11.22-1.218 14.62-3.655 3.4-2.437 5.1-5.412 5.1-8.925 0-3.06-1.615-5.582-4.845-7.565-3.23-1.983-7.253-3.428-12.07-4.335s-10.058-2.182-15.725-3.825c-5.667-1.643-10.908-3.542-15.725-5.695-4.817-2.153-8.84-5.553-12.07-10.2-3.23-4.647-4.845-10.313-4.845-17 0-9.747 3.91-17.935 11.73-24.565 7.82-6.63 18.247-9.945 31.28-9.945 18.02 0 32.753 5.27 44.2 15.81l-13.43 18.02c-8.953-8.273-19.947-12.41-32.98-12.41-4.987 0-8.897 1.02-11.73 3.06s-4.25 4.76-4.25 8.16c0 2.72 1.615 4.987 4.845 6.8 3.23 1.813 7.253 3.202 12.07 4.165 4.817.963 10.03 2.295 15.64 3.995 5.61 1.7 10.823 3.655 15.64 5.865 4.817 2.21 8.84 5.638 12.07 10.285 3.23 4.647 4.845 10.313 4.845 17 0 10.88-3.882 19.663-11.645 26.35-7.763 6.687-19.012 10.03-33.745 10.03ZM510.25 218.04c-15.413 0-23.12-7.537-23.12-22.61v-42.67h-13.6v-18.87h13.6v-22.44h21.59v22.44h16.66v18.87h-16.66v36.89c0 2.72.652 4.93 1.955 6.63 1.303 1.7 3.145 2.55 5.525 2.55 3.513 0 6.007-.85 7.48-2.55l4.59 16.49c-3.967 3.513-9.973 5.27-18.02 5.27ZM611.23 216h-21.76v-8.67c-5.893 7.14-14.563 10.71-26.01 10.71-7.253 0-13.798-2.408-19.635-7.225-5.837-4.817-8.755-11.475-8.755-19.975 0-8.953 2.833-15.612 8.5-19.975 5.667-4.363 12.297-6.545 19.89-6.545 11.673 0 20.343 3.343 26.01 10.03v-10.37c0-4.193-1.643-7.537-4.93-10.03-3.287-2.493-7.65-3.74-13.09-3.74-8.727 0-16.603 3.23-23.63 9.69l-8.5-15.13c9.633-8.613 21.59-12.92 35.87-12.92 10.54 0 19.182 2.437 25.925 7.31 6.743 4.873 10.115 12.807 10.115 23.8V216Zm-39.1-12.58c8.047 0 13.827-2.38 17.34-7.14v-10.2c-3.627-4.873-9.407-7.31-17.34-7.31-4.42 0-8.103 1.133-11.05 3.4-2.947 2.267-4.42 5.27-4.42 9.01s1.473 6.715 4.42 8.925c2.947 2.21 6.63 3.315 11.05 3.315ZM660.02 218.04c-15.413 0-23.12-7.537-23.12-22.61v-42.67h-13.6v-18.87h13.6v-22.44h21.59v22.44h16.66v18.87h-16.66v36.89c0 2.72.652 4.93 1.955 6.63 1.303 1.7 3.145 2.55 5.525 2.55 3.513 0 6.007-.85 7.48-2.55l4.59 16.49c-3.967 3.513-9.973 5.27-18.02 5.27ZM700.65 125.05c-3.513 0-6.517-1.275-9.01-3.825-2.493-2.55-3.74-5.582-3.74-9.095 0-3.513 1.247-6.517 3.74-9.01 2.493-2.493 5.497-3.74 9.01-3.74 3.627 0 6.687 1.247 9.18 3.74 2.493 2.493 3.74 5.497 3.74 9.01s-1.247 6.545-3.74 9.095c-2.493 2.55-5.553 3.825-9.18 3.825ZM711.53 216h-21.59v-82.11h21.59V216ZM802.65 205.63c-7.933 8.273-18.473 12.41-31.62 12.41-13.147 0-23.658-4.165-31.535-12.495-7.877-8.33-11.815-18.558-11.815-30.685 0-12.127 3.938-22.327 11.815-30.6 7.877-8.273 18.388-12.41 31.535-12.41 13.147 0 23.687 4.137 31.62 12.41s11.9 18.473 11.9 30.6c0 12.127-3.967 22.383-11.9 30.77Zm-31.62-6.8c6.573 0 11.73-2.295 15.47-6.885s5.61-10.285 5.61-17.085c0-6.687-1.87-12.325-5.61-16.915s-8.897-6.885-15.47-6.885c-6.46 0-11.56 2.295-15.3 6.885s-5.61 10.228-5.61 16.915c0 6.8 1.87 12.495 5.61 17.085 3.74 4.59 8.84 6.885 15.3 6.885ZM907.88 216h-21.76v-49.64c0-10.2-5.043-15.3-15.13-15.3-7.48 0-13.713 3.173-18.7 9.52V216H830.7v-82.11h21.59v10.54c2.947-3.513 6.942-6.488 11.985-8.925 5.043-2.437 10.625-3.655 16.745-3.655 8.84 0 15.527 2.323 20.06 6.97 4.533 4.647 6.8 11.05 6.8 19.21V216Z" />
      </g>
    </g>
  </svg>
);
export const StationText = memo(_StationText);
StationText.displayName = "StationText";

const _Trust = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <defs>
      <linearGradient
        id="trust_a"
        x1="39.343%"
        x2="55.431%"
        y1="112.568%"
        y2="-19.008%">
        <stop offset="26%" stopColor="#48FF91" />
        <stop offset="66%" stopColor="#0094FF" />
        <stop offset="80%" stopColor="#0038FF" />
        <stop offset="89%" stopColor="#0500FF" />
      </linearGradient>
      <linearGradient
        id="trust_b"
        x1="54.239%"
        x2="39.393%"
        y1="-5.78%"
        y2="99.857%">
        <stop offset="2%" stopColor="#00F" />
        <stop offset="8%" stopColor="#0094FF" />
        <stop offset="16%" stopColor="#48FF91" />
        <stop offset="42%" stopColor="#0094FF" />
        <stop offset="68%" stopColor="#0038FF" />
        <stop offset="90%" stopColor="#0500FF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#0500FF"
        d="M17 43.336 150 0v300C54.998 259.996 17 183.33 17 140.004V43.336Z"
      />
      <path
        fill="url(#trust_a)"
        d="M266 43.336 133 0v300c95.001-40.004 133-116.67 133-159.996V43.336Z"
        transform="translate(17)"
      />
      <path
        fill="url(#trust_b)"
        d="M266 43.336 133 0v300c95.001-40.004 133-116.67 133-159.996V43.336Z"
        transform="translate(17)"
      />
    </g>
  </svg>
);
export const Trust = memo(_Trust);
Trust.displayName = "Trust";

const _TrustSimple = ({ ...props }: CustomProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <path
      d="m150 0 133 43.336v96.668C283 183.33 245.001 259.996 150 300 54.998 259.996 17 183.33 17 140.004V43.336L150 0Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export const TrustSimple = memo(_TrustSimple);
TrustSimple.displayName = "TrustSimple";

const _TrustText = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 293 80" {...props}>
    <defs>
      <linearGradient
        id="trust_t_a"
        x1="39.29%"
        x2="55.458%"
        y1="112.568%"
        y2="-19.008%">
        <stop offset="26%" stopColor="#48FF91" />
        <stop offset="66%" stopColor="#0094FF" />
        <stop offset="80%" stopColor="#0038FF" />
        <stop offset="89%" stopColor="#0500FF" />
      </linearGradient>
      <linearGradient
        id="trust_t_b"
        x1="54.26%"
        x2="39.341%"
        y1="-5.78%"
        y2="99.857%">
        <stop offset="2%" stopColor="#00F" />
        <stop offset="8%" stopColor="#0094FF" />
        <stop offset="16%" stopColor="#48FF91" />
        <stop offset="42%" stopColor="#0094FF" />
        <stop offset="68%" stopColor="#0038FF" />
        <stop offset="90%" stopColor="#0500FF" />
      </linearGradient>
    </defs>
    <g fill="none">
      <path
        fill="currentColor"
        d="M131.99 18.695h13.938v7.806c4.566-7.015 9.82-7.806 17.513-7.806v13.796h-3.503c-9.218 0-13.63 4.337-13.63 12.93v14.663H131.99V18.695Zm77.95 41.389h-14.313v-3.946c-3.126 3.628-7.386 5.204-12.638 5.204-9.974 0-15.613-5.914-15.613-16.79V18.695h14.314v22.629c0 5.12 2.513 8.115 6.775 8.115 4.262 0 7.159-2.92 7.159-7.882V18.695h14.314v41.39h.002Zm3.498-12.779h13.406c.61 2.995 2.667 4.255 7.612 4.255 4.038 0 6.398-.944 6.398-2.678 0-1.343-1.143-2.212-4.413-2.92l-10.813-2.444c-7.235-1.652-10.891-5.831-10.891-12.536 0-8.833 6.47-13.404 19.036-13.404 12.564 0 18.73 4.455 19.8 13.998h-13.322c-.226-2.52-2.82-4.063-7.082-4.063-3.425 0-5.63 1.102-5.63 2.761 0 1.419 1.444 2.52 4.343 3.236l11.344 2.76c7.46 1.81 11.044 5.598 11.044 11.746 0 8.516-7.388 13.562-19.945 13.562-12.558 0-20.865-5.44-20.865-14.273h-.022Zm78.95-15.736V18.695h-35.332v12.881h10.543v28.508h14.241V31.569zm-164.382 0V18.695H92.677v12.881h10.543v28.508h14.243V31.569z"
      />
      <path
        fill="#0500FF"
        d="M0 11.421 35.14 0v79.066C10.04 68.523 0 48.317 0 36.898V11.421Z"
      />
      <path
        fill="url(#trust_t_a)"
        d="M70.282 11.421 35.142 0v79.066c25.1-10.543 35.14-30.749 35.14-42.168V11.421Z"
      />
      <path
        fill="url(#trust_t_b)"
        d="M70.282 11.421 35.142 0v79.066c25.1-10.543 35.14-30.749 35.14-42.168V11.421Z"
      />
    </g>
  </svg>
);
export const TrustText = memo(_TrustText);
TrustText.displayName = "TrustText";

const _Tronlink = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M33.726 0C15.098 0 0 16.61 0 37.1v225.8C0 283.39 15.098 300 33.726 300h232.548C284.9 300 300 283.39 300 262.9V37.1C300 16.61 284.9 0 266.274 0H33.726Z"
      fill="#0D1FFF"
      fillRule="evenodd"
    />
    <path
      fill="#FFF"
      d="M55.385 64.615 300 109.52v21.285L111.456 96.193l132.509 109.634L300 159.243v27.249l-28.731 23.885L300 205.186v21.273l-45.48 8.217L246.603 300h-21.136l9.062-74.784-138.1-114.259L171.745 300h-22.582z"
    />
  </svg>
);
export const Tronlink = memo(_Tronlink);
Tronlink.displayName = "Tronlink";

const _TronlinkSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M33.726 0C15.098 0 0 16.61 0 37.1v225.8C0 283.39 15.098 300 33.726 300h232.548C284.9 300 300 283.39 300 262.9V37.1C300 16.61 284.9 0 266.274 0H33.726Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      fill="#FFF"
      d="M55.385 64.615 300 109.52v21.285L111.456 96.193l132.509 109.634L300 159.243v27.249l-28.731 23.885L300 205.186v21.273l-45.48 8.217L246.603 300h-21.136l9.062-74.784-138.1-114.259L171.745 300h-22.582z"
    />
  </svg>
);
export const TronlinkSimple = memo(_TronlinkSimple);
TronlinkSimple.displayName = "TronlinkSimple";

const _Sonar = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 800.219 837" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fillRule="nonzero" fill="none">
      <path
        d="M753.342 388.67c-2.09 97.896-126.396 314.217-222.746 360.745-96.35 46.529-274.767-29.344-355.351-81.574-80.584-52.229-124.91-135.15-128.154-231.8-3.244-96.65 26.016-302.431 108.69-348.097 82.676-45.666 287.768 23.98 387.362 74.1 99.593 50.121 212.29 128.732 210.2 226.627-2.092 97.895-126.397 314.216-222.747 360.744"
        fill="#60FBD0"
        opacity=".6"
      />
      <path
        d="M759.478 353.783c-6.476 132.996-89.197 381.408-173.882 447.982-84.685 66.574-243.362 32.312-334.227-48.539-90.866-80.85-205.925-340.513-210.963-436.567-5.039-96.053 83.392-87.61 180.733-139.755C318.481 124.76 534.73-25.688 624.453 3.792c89.723 29.48 141.501 216.996 135.025 349.991-6.476 132.996-89.197 381.408-173.882 447.982"
        fill="#1E92E6"
        opacity=".35"
      />
      <path
        d="M799.969 412.336c6.98 95.18-133.648 222.531-232.285 277.154-98.637 54.623-264.923 93.71-359.536 50.585C113.535 696.949.7 534.919.003 430.737-.688 326.555 116.346 167.04 203.98 114.983c87.633-52.055 222.496-46.137 321.828 3.422 99.331 49.559 267.181 198.75 274.16 293.931 6.98 95.18-133.647 222.531-232.284 277.154"
        fill="#1E92E6"
        opacity=".45"
      />
      <g fill="#FFF">
        <path d="M292.295 418.494a107.847 107.847 0 0 0 31.595 76.266 107.85 107.85 0 0 0 152.532 0 107.85 107.85 0 0 0 0-152.532 107.85 107.85 0 0 0-152.532 0 107.85 107.85 0 0 0-31.595 76.266Zm161.79 0a53.95 53.95 0 0 1-15.796 38.136 53.949 53.949 0 0 1-38.136 15.795 53.95 53.95 0 0 1-38.136-15.795 53.949 53.949 0 0 1-15.795-38.136 53.95 53.95 0 0 1 15.795-38.136 53.949 53.949 0 0 1 38.136-15.795 53.95 53.95 0 0 1 38.136 15.795 53.949 53.949 0 0 1 15.795 38.136ZM514.755 560.06c0-14.893 12.076-26.968 26.968-26.968s26.962 12.075 26.962 26.967-12.07 26.963-26.962 26.963-26.968-12.07-26.968-26.963" />
        <path d="M400.155 634.213a217.013 217.013 0 0 0 38.493-3.503 26.978 26.978 0 0 0 17.87-10.98 26.963 26.963 0 0 0-6.861-38.033 26.955 26.955 0 0 0-20.583-4.044 161.794 161.794 0 0 1-128.842-31.915 161.813 161.813 0 0 1-61.6-117.572 161.808 161.808 0 0 1 47.098-124.098 161.79 161.79 0 0 1 241.671 14.502 161.79 161.79 0 0 1 31.915 128.841 26.964 26.964 0 0 0 35.55 29.525 26.97 26.97 0 0 0 17.506-19.95 215.728 215.728 0 0 0-103.728-224.917 215.69 215.69 0 0 0-126.7-28.524 215.684 215.684 0 0 0-120.11 49.38 215.706 215.706 0 0 0-69.998 109.385 215.761 215.761 0 0 0 5.483 129.756 215.718 215.718 0 0 0 78.984 103.09 215.701 215.701 0 0 0 123.846 39.066l.006-.01Z" />
      </g>
    </g>
  </svg>
);
export const Sonar = memo(_Sonar);
Sonar.displayName = "Sonar";

const _SonarSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M150.026 300a149.987 149.987 0 0 1-86.115-27.165A149.997 149.997 0 0 1 137.368.533a149.98 149.98 0 0 1 88.1 19.834 150.004 150.004 0 0 1 72.127 156.393 18.754 18.754 0 0 1-30.337 10.597 18.754 18.754 0 0 1-6.556-17.254A112.498 112.498 0 0 0 156.757 37.681a112.5 112.5 0 0 0-119.04 119.04 112.515 112.515 0 0 0 42.833 81.753A112.503 112.503 0 0 0 168.2 261l1.94-.335a18.754 18.754 0 0 1 22.28 15.028c.899 4.979-.256 10.11-3.198 14.23a18.759 18.759 0 0 1-12.425 7.634 150.977 150.977 0 0 1-23.402 2.393l-3.369.049Zm.005-75.004A74.992 74.992 0 0 1 97 203.026a74.99 74.99 0 0 1 0-106.061 74.992 74.992 0 0 1 106.062 0 74.992 74.992 0 0 1 0 106.061 74.992 74.992 0 0 1-53.03 21.97Zm-.002-37.5a37.513 37.513 0 0 0 26.518-10.983 37.514 37.514 0 0 0 10.983-26.517 37.513 37.513 0 0 0-10.983-26.518 37.514 37.514 0 0 0-26.518-10.983 37.513 37.513 0 0 0-26.517 10.983 37.514 37.514 0 0 0-10.983 26.518 37.513 37.513 0 0 0 10.983 26.517 37.514 37.514 0 0 0 26.517 10.983Zm98.44 79.684c-10.355 0-18.752-8.393-18.752-18.748s8.397-18.752 18.752-18.752c10.355 0 18.748 8.397 18.748 18.752 0 10.355-8.393 18.748-18.748 18.748Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export const SonarSimple = memo(_SonarSimple);
SonarSimple.displayName = "SonarSimple";

const _SonarText = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 468 141" {...props}>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#60FBD0"
        d="M188.082 65.475c-.352 16.491-21.293 52.932-37.524 60.77-16.23 7.839-46.287-4.943-59.862-13.741-13.575-8.799-21.042-22.768-21.588-39.05-.547-16.28 4.382-50.946 18.31-58.64 13.927-7.692 48.477 4.04 65.254 12.484 16.777 8.443 35.762 21.686 35.41 38.177-.352 16.491-21.293 52.932-37.524 60.77"
        opacity=".6"
      />
      <path
        fill="#1E92E6"
        d="M189.116 59.598c-1.091 22.404-15.027 64.251-29.292 75.466-14.266 11.215-40.997 5.444-56.304-8.176-15.307-13.62-34.69-57.363-35.539-73.544-.848-16.181 14.049-14.759 30.447-23.543 16.398-8.784 52.827-34.128 67.941-29.162 15.115 4.966 23.837 36.555 22.747 58.959-1.091 22.404-15.027 64.251-29.292 75.466"
        opacity=".35"
      />
      <path
        fill="#1E92E6"
        d="M195.936 69.462c1.176 16.034-22.514 37.487-39.13 46.689-16.616 9.201-44.629 15.786-60.567 8.521-15.938-7.265-34.946-34.56-35.064-52.11-.116-17.55 19.6-44.423 34.362-53.192 14.763-8.77 37.481-7.772 54.215.576 16.733 8.349 45.009 33.482 46.184 49.516 1.176 16.034-22.514 37.487-39.13 46.689"
        opacity=".45"
      />
      <g fill="#FFF">
        <path d="M110.414 70.499a18.168 18.168 0 0 0 18.17 18.17 18.168 18.168 0 0 0 18.17-18.17 18.168 18.168 0 0 0-18.17-18.17 18.168 18.168 0 0 0-18.17 18.17Zm27.255 0a9.088 9.088 0 0 1-9.085 9.085A9.088 9.088 0 0 1 119.5 70.5a9.088 9.088 0 0 1 9.085-9.085 9.088 9.088 0 0 1 9.085 9.085ZM147.89 94.347a4.543 4.543 0 1 1 9.086 0 4.543 4.543 0 0 1-9.086 0" />
        <path d="M128.584 106.839a36.558 36.558 0 0 0 6.485-.59 4.545 4.545 0 0 0 3.785-5.297 4.543 4.543 0 0 0-5.398-3.641 27.256 27.256 0 1 1 21.94-21.94 4.544 4.544 0 0 0 8.938 1.612 36.341 36.341 0 1 0-35.75 29.857v-.001Z" />
      </g>
      <g fill="#FFF">
        <path d="M27.1 105c18 0 25.8-9.5 25.8-20.6 0-24.9-38.8-17.2-38.8-29.6 0-5 4.4-8.3 11.3-8.3 7 0 14.1 2.4 19.3 7.6l6.7-8.7c-6.2-6-14.6-9.3-25-9.3-14.6 0-24.3 8.5-24.3 19.5C2.1 80.2 41 71.5 41 85.5c0 4.4-3.8 9.1-13.4 9.1-9.3 0-16.5-4.3-21.1-9.2l-6.5 9c5.9 6.3 14.8 10.6 27.1 10.6ZM265.857 103.8V37.1h-11.7v46.3l-34.1-46.3h-12v66.7h11.7V56.2l34.8 47.6zM373.986 103.8l-26.2-66.7h-14.6l-26.2 66.7h13.3l4.9-12.8h30.6l4.9 12.8h13.3Zm-21.5-23.1h-24l12-31.8 12 31.8ZM466.814 103.8l-16.3-26.2c8-1.3 15.8-7.7 15.8-19.6 0-12.3-8.6-20.9-21.8-20.9h-29.3v66.7h11.7V78.9h11.6l14.8 24.9h13.5Zm-23.9-35.2h-16V47.4h16c6.6 0 11.4 4.2 11.4 10.6 0 6.4-4.8 10.6-11.4 10.6Z" />
      </g>
    </g>
  </svg>
);
export const SonarText = memo(_SonarText);
SonarText.displayName = "SonarText";

const _Vultisig = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 43 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="m20.814 23.972-17.276 10L1 31.432l15.145-10.176 4.669 2.715Z"
      fill="url(#vultisig_a)"
    />
    <path
      d="M21.204 24.648 3.907 34.61l.929 3.467 16.385-8.028-.017-5.4Z"
      fill="url(#vultisig_b)"
    />
    <path
      d="M21.891 24.648 39.19 34.61l-.93 3.467-16.384-8.028.016-5.4Z"
      fill="url(#vultisig_c)"
    />
    <path
      d="m22.282 23.972 17.275 10 2.539-2.539L26.95 21.257l-4.67 2.715Z"
      fill="url(#vultisig_d)"
    />
    <path
      d="M21.891 23.233 21.87 3.272l3.467-.93 1.241 18.204-4.686 2.687Z"
      fill="url(#vultisig_e)"
    />
    <path
      d="m21.11 23.233.022-19.961-3.467-.93-1.24 18.204 4.685 2.687Z"
      fill="url(#vultisig_f)"
    />
    <path
      d="m20.814 23.972-17.276 10L1 31.432l15.145-10.176 4.669 2.715Z"
      stroke="url(#vultisig_g)"
      strokeWidth=".227"
    />
    <path
      d="M21.204 24.648 3.907 34.61l.929 3.467 16.385-8.028-.017-5.4Z"
      stroke="url(#vultisig_h)"
      strokeWidth=".227"
    />
    <path
      d="M21.891 24.648 39.19 34.61l-.93 3.467-16.384-8.028.016-5.4Z"
      stroke="url(#vultisig_i)"
      strokeWidth=".227"
    />
    <path
      d="m22.282 23.972 17.275 10 2.539-2.539L26.95 21.257l-4.67 2.715Z"
      stroke="url(#vultisig_j)"
      strokeWidth=".227"
    />
    <path
      d="M21.891 23.233 21.87 3.272l3.467-.93 1.241 18.204-4.686 2.687Z"
      stroke="url(#vultisig_k)"
      strokeWidth=".227"
    />
    <path
      d="m21.11 23.233.022-19.961-3.467-.93-1.24 18.204 4.685 2.687Z"
      stroke="url(#vultisig_l)"
      strokeWidth=".227"
    />
    <defs>
      <linearGradient
        id="vultisig_a"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_b"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_c"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_d"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_e"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_f"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_g"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_h"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_i"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_j"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_k"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
      <linearGradient
        id="vultisig_l"
        x1="21.548"
        y1="2.343"
        x2="21.548"
        y2="38.077"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#33E6BF" />
        <stop offset="1" stopColor="#0439C7" />
      </linearGradient>
    </defs>
  </svg>
);

export const Vultisig = memo(_Vultisig);
Vultisig.displayName = "Vultisig";

const _VultisigSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M144.161 177.375 18.466 250.134 0 231.652l110.19-74.038zM147.002 182.294 21.154 254.775 27.913 280l119.212-58.41zM151.998 182.294l125.863 72.481L271.095 280l-119.206-58.41.117-39.289zM154.839 177.375l125.687 72.759L299 231.66l-110.198-74.039-33.977 19.754zM151.995 171.998l-.153-145.232L177.067 20l9.029 132.448zM146.312 171.998l.16-145.232L121.247 20l-9.022 132.448z" />
      <path d="M144.161 177.375 18.466 250.134 0 231.652l110.19-74.038zM147.002 182.294 21.154 254.775 27.913 280l119.212-58.41zM151.998 182.294l125.863 72.481L271.095 280l-119.206-58.41.117-39.289zM154.839 177.375l125.687 72.759L299 231.66l-110.198-74.039-33.977 19.754zM151.995 171.998l-.153-145.232L177.067 20l9.029 132.448zM146.312 171.998l.16-145.232L121.247 20l-9.022 132.448z" />
    </g>
  </svg>
);

export const VultisigSimple = memo(_VultisigSimple);
VultisigSimple.displayName = "VultisigSimple";

const _VultisigText = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 203 41" {...props}>
    <defs>
      <linearGradient
        x1="103.704%"
        y1="-148.734%"
        x2="103.704%"
        y2="132.282%"
        id="vt_a">
        <stop stopColor="#33E6BF" offset="0%" />
        <stop stopColor="#0439C7" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="101.889%"
        y1="-166.096%"
        x2="101.889%"
        y2="100%"
        id="vt_b">
        <stop stopColor="#33E6BF" offset="0%" />
        <stop stopColor="#0439C7" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-1.894%"
        y1="-166.096%"
        x2="-1.894%"
        y2="100%"
        id="vt_c">
        <stop stopColor="#33E6BF" offset="0%" />
        <stop stopColor="#0439C7" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-3.694%"
        y1="-148.753%"
        x2="-3.694%"
        y2="132.285%"
        id="vt_d">
        <stop stopColor="#33E6BF" offset="0%" />
        <stop stopColor="#0439C7" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-6.839%"
        y1=".005%"
        x2="-6.839%"
        y2="171.055%"
        id="vt_e">
        <stop stopColor="#33E6BF" offset="0%" />
        <stop stopColor="#0439C7" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="108.838%"
        y1=".005%"
        x2="108.838%"
        y2="171.055%"
        id="vt_f">
        <stop stopColor="#33E6BF" offset="0%" />
        <stop stopColor="#0439C7" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="url(#vt_a)"
        fillRule="nonzero"
        d="m19.814 21.63-17.276 10L0 29.09l15.145-10.176 4.669 2.715z"
      />
      <path
        fill="url(#vt_b)"
        fillRule="nonzero"
        d="M20.204 22.306 2.907 32.268l.929 3.467 16.385-8.028-.017-5.4z"
      />
      <path
        fill="url(#vt_c)"
        fillRule="nonzero"
        d="m20.891 22.306 17.299 9.962-.93 3.467-16.384-8.028.016-5.4z"
      />
      <path
        fill="url(#vt_d)"
        fillRule="nonzero"
        d="m21.282 21.63 17.275 10 2.539-2.539L25.95 18.915l-4.67 2.715z"
      />
      <path
        fill="url(#vt_e)"
        fillRule="nonzero"
        d="M20.891 20.891 20.87.93 24.337 0l1.241 18.204-4.686 2.687z"
      />
      <path
        fill="url(#vt_f)"
        fillRule="nonzero"
        d="M20.11 20.891 20.132.93 16.665 0l-1.24 18.204z"
      />
      <path
        stroke="url(#vt_a)"
        strokeWidth=".227"
        d="m19.814 21.63-17.276 10L0 29.09l15.145-10.176 4.669 2.715z"
      />
      <path
        stroke="url(#vt_b)"
        strokeWidth=".227"
        d="M20.204 22.306 2.907 32.268l.929 3.467 16.385-8.028-.017-5.4z"
      />
      <path
        stroke="url(#vt_c)"
        strokeWidth=".227"
        d="m20.891 22.306 17.299 9.962-.93 3.467-16.384-8.028.016-5.4z"
      />
      <path
        stroke="url(#vt_d)"
        strokeWidth=".227"
        d="m21.282 21.63 17.275 10 2.539-2.539L25.95 18.915l-4.67 2.715z"
      />
      <path
        stroke="url(#vt_e)"
        strokeWidth=".227"
        d="M20.891 20.891 20.87.93 24.337 0l1.241 18.204-4.686 2.687z"
      />
      <path
        stroke="url(#vt_f)"
        strokeWidth=".227"
        d="M20.11 20.891 20.132.93 16.665 0l-1.24 18.204z"
      />
      <g fill="#FFF" fillRule="nonzero">
        <path d="M53.633 32 41 3h7.32l11.043 25.686h-4.308L66.265 3H73L60.325 32zM83.284 32c-1.803 0-3.41-.35-4.823-1.048-1.413-.698-2.51-1.766-3.29-3.203-.78-1.437-1.171-3.27-1.171-5.5V10h6.297v11.322c0 1.8.384 3.123 1.15 3.97.768.845 1.85 1.268 3.25 1.268.97 0 1.83-.208 2.584-.624.753-.416 1.345-1.061 1.776-1.934.43-.873.646-1.968.646-3.284V10H96v21.678h-5.974v-5.964l1.09 1.733c-.727 1.504-1.797 2.64-3.21 3.405-1.412.765-2.953 1.148-4.622 1.148ZM102 33V2h7v31zM124.747 32c-2.62 0-4.66-.656-6.122-1.97-1.461-1.312-2.192-3.268-2.192-5.866V5h6.453v19.083c0 .92.248 1.63.744 2.131.497.501 1.172.751 2.027.751 1.02 0 1.889-.27 2.606-.812L130 30.62c-.662.46-1.455.805-2.378 1.035a11.85 11.85 0 0 1-2.875.345ZM113 15.191v-4.872h15.428v4.872H113ZM133.881 32V10.125h7.238V32h-7.238ZM137.5 7.075c-1.33 0-2.412-.339-3.247-1.017-.835-.677-1.253-1.518-1.253-2.52 0-1.003.418-1.844 1.253-2.521C135.088.339 136.17 0 137.5 0c1.33 0 2.412.319 3.247.956S142 2.413 142 3.416c0 1.057-.41 1.93-1.23 2.622-.819.691-1.91 1.037-3.27 1.037ZM154.569 32c-1.89 0-3.703-.218-5.442-.655-1.738-.437-3.114-.986-4.127-1.648l2.136-4.448c1.013.609 2.21 1.105 3.593 1.49 1.383.383 2.745.575 4.086.575 1.479 0 2.526-.172 3.142-.516.616-.344.924-.82.924-1.43 0-.503-.24-.88-.719-1.132-.479-.251-1.115-.443-1.91-.575a102.14 102.14 0 0 0-2.607-.397 31.766 31.766 0 0 1-2.854-.537 9.876 9.876 0 0 1-2.629-1.012 5.29 5.29 0 0 1-1.91-1.827c-.479-.768-.718-1.76-.718-2.978 0-1.35.404-2.542 1.211-3.574.808-1.033 1.978-1.847 3.512-2.442 1.533-.596 3.367-.894 5.503-.894 1.506 0 3.039.159 4.6.477 1.56.317 2.86.78 3.9 1.39l-2.135 4.407c-1.068-.609-2.142-1.026-3.224-1.25a15.41 15.41 0 0 0-3.141-.338c-1.424 0-2.464.185-3.121.556-.657.37-.986.847-.986 1.43 0 .529.24.926.719 1.19.479.266 1.115.477 1.91.636a36.86 36.86 0 0 0 2.607.417c.945.12 1.896.298 2.854.536.959.239 1.828.576 2.608 1.013a5.403 5.403 0 0 1 1.91 1.787c.493.754.739 1.74.739 2.958 0 1.324-.41 2.496-1.232 3.515-.821 1.02-2.006 1.82-3.552 2.402-1.547.583-3.43.874-5.647.874ZM167.881 32V10.125h7.238V32h-7.238ZM171.5 7.075c-1.33 0-2.412-.339-3.247-1.017-.835-.677-1.253-1.518-1.253-2.52 0-1.003.418-1.844 1.253-2.521C169.088.339 170.17 0 171.5 0c1.33 0 2.412.319 3.247.956S176 2.413 176 3.416c0 1.057-.41 1.93-1.23 2.622-.819.691-1.91 1.037-3.27 1.037ZM190.818 41a22.6 22.6 0 0 1-5.909-.767c-1.896-.51-3.475-1.278-4.74-2.3l2.502-4.642c.914.774 2.077 1.389 3.489 1.845 1.411.456 2.803.684 4.174.684 2.232 0 3.853-.512 4.861-1.534 1.008-1.022 1.513-2.542 1.513-4.559V26.37l.403-5.595-.08-5.636v-4.807H203v18.566c0 4.145-1.049 7.198-3.146 9.16-2.098 1.961-5.11 2.942-9.036 2.942Zm-.968-9.45c-2.016 0-3.838-.448-5.465-1.346a10.38 10.38 0 0 1-3.913-3.772c-.981-1.616-1.472-3.502-1.472-5.657 0-2.182.49-4.082 1.472-5.698.982-1.616 2.286-2.867 3.913-3.75 1.627-.885 3.449-1.327 5.465-1.327 1.829 0 3.442.38 4.84 1.14 1.4.76 2.488 1.934 3.268 3.522.78 1.59 1.17 3.627 1.17 6.113 0 2.46-.39 4.483-1.17 6.072-.78 1.589-1.869 2.77-3.267 3.543-1.399.774-3.012 1.16-4.84 1.16Zm1.25-5.304c1.103 0 2.085-.228 2.945-.684a4.995 4.995 0 0 0 2.017-1.927c.484-.829.726-1.782.726-2.86 0-1.105-.242-2.065-.726-2.88a5.038 5.038 0 0 0-2.017-1.906c-.86-.456-1.842-.684-2.944-.684-1.103 0-2.084.228-2.945.684a5.18 5.18 0 0 0-2.037 1.906c-.497.815-.746 1.775-.746 2.88 0 1.078.249 2.031.746 2.86a5.134 5.134 0 0 0 2.037 1.927c.86.456 1.842.684 2.945.684Z" />
      </g>
    </g>
  </svg>
);

export const VultisigText = memo(_VultisigText);
VultisigText.displayName = "VultisigText";

const _Xaman = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M236 0H64C28.654 0 0 28.654 0 64v172c0 35.346 28.654 64 64 64h172c35.346 0 64-28.654 64-64V64c0-35.346-28.654-64-64-64Z"
        fill="#0030CF"
        fillRule="nonzero"
      />
      <path
        d="M270.295 130.814c6.725-7.287 6.174-18.561-1.226-25.182-7.4-6.62-18.852-6.08-25.573 1.208l-48.224 52.26-19.496-20.155c-6.895-7.13-18.356-7.405-25.597-.615a17.634 17.634 0 0 0-.624 25.203l32.92 34.034c3.467 3.585 8.294 5.589 13.323 5.53 5.028-.058 9.807-2.172 13.186-5.837l61.31-66.446Zm-136.488 44.747-21.006-20.869 21.006-20.868c4.541-4.472 6.812-8.26 6.812-11.366 0-3.23-2.271-7.08-6.812-11.552-4.542-4.472-8.39-6.708-11.544-6.708-3.153 0-7.001 2.236-11.543 6.708l-20.816 20.869-21.005-20.87c-4.541-4.471-8.39-6.707-11.543-6.707-3.028 0-6.876 2.236-11.544 6.708-4.541 4.471-6.812 8.322-6.812 11.552 0 3.106 2.27 6.894 6.812 11.366l21.006 20.868-21.006 20.869C41.271 180.033 39 183.883 39 187.113c0 3.105 2.27 6.895 6.812 11.365C50.48 202.827 54.328 205 57.356 205c3.154 0 7.002-2.235 11.543-6.707l21.005-20.682 20.816 20.682c4.542 4.472 8.39 6.707 11.543 6.707 3.155 0 7.002-2.173 11.544-6.522 4.541-4.47 6.812-8.26 6.812-11.365 0-3.23-2.271-7.08-6.812-11.552Z"
        fill="#FFF"
      />
    </g>
  </svg>
);

export const Xaman = memo(_Xaman);
Xaman.displayName = "Xaman";

const _XamanSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M236 0c35.346 0 64 28.654 64 64v172c0 35.346-28.654 64-64 64H64c-35.346 0-64-28.654-64-64V64C0 28.654 28.654 0 64 0ZM122.263 104.198c-3.153 0-7.001 2.236-11.543 6.708l-20.816 20.869-21.005-20.87c-4.541-4.471-8.39-6.707-11.543-6.707-3.028 0-6.876 2.236-11.544 6.708-4.541 4.471-6.812 8.322-6.812 11.552 0 3.106 2.27 6.894 6.812 11.366l21.006 20.868-21.006 20.869C41.271 180.033 39 183.883 39 187.113c0 3.105 2.27 6.895 6.812 11.365C50.48 202.827 54.328 205 57.356 205c3.154 0 7.002-2.235 11.543-6.707l21.005-20.682 20.816 20.682c4.542 4.472 8.39 6.707 11.543 6.707 3.155 0 7.002-2.173 11.544-6.522 4.541-4.47 6.812-8.26 6.812-11.365 0-3.23-2.271-7.08-6.812-11.552l-21.006-20.869 21.006-20.868c4.541-4.472 6.812-8.26 6.812-11.366 0-3.23-2.271-7.08-6.812-11.552-4.542-4.472-8.39-6.708-11.544-6.708Zm121.233 2.642-48.224 52.26-19.496-20.155c-6.895-7.13-18.356-7.405-25.597-.615a17.634 17.634 0 0 0-.624 25.203l32.92 34.034c3.467 3.585 8.294 5.589 13.323 5.53 5.028-.058 9.807-2.172 13.186-5.837l61.31-66.446c6.726-7.287 6.175-18.561-1.225-25.182-7.4-6.62-18.852-6.08-25.573 1.208Z"
      fillRule="nonzero"
      fill="currentColor"
    />
  </svg>
);

export const XamanSimple = memo(_XamanSimple);
XamanSimple.displayName = "XamanSimple";

const _XamanText = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 332 48" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m42.303 15.569-9.572 9.693 9.315 9.432c2.014 2.021 3.021 3.762 3.021 5.221 0 1.404-1.007 3.116-3.02 5.138C40.031 47.018 38.324 48 36.926 48c-1.399 0-3.105-1.01-5.12-3.032l-9.231-9.347-9.316 9.347C11.246 46.99 9.54 48 8.14 48c-1.342 0-3.049-.983-5.119-2.947C1.007 43.03 0 41.319 0 39.916c0-1.397.921-3.05 2.764-4.96l9.573-9.694-9.316-9.431C1.007 13.81 0 12.097 0 10.694c0-1.46 1.007-3.2 3.021-5.222 2.07-2.02 3.777-3.031 5.12-3.031 1.398 0 3.105 1.01 5.119 3.031l9.316 9.432 9.231-9.432c2.015-2.02 3.721-3.031 5.12-3.031 1.398 0 3.105 1.01 5.12 3.031 2.013 2.021 3.02 3.762 3.02 5.222 0 1.342-.921 2.967-2.764 4.875ZM76.778 7.83c.336-3.144 2.546-4.716 6.63-4.716 2.182 0 3.805.169 4.868.506.981.31 1.676.837 2.086 1.578l.096.19c.448.842.7 1.6.755 2.274.112.617.168 1.572.168 2.863V40l-.005.673c-.017.965-.071 1.723-.163 2.274-.056.618-.28 1.348-.671 2.19-.783 1.46-2.714 2.19-5.79 2.19-3.022 0-5.064-.366-6.127-1.096-1.007-.785-1.595-1.908-1.763-3.368-2.07 2.976-5.539 4.463-10.406 4.463-4.812 0-9.288-2.217-13.428-6.653-4.14-4.435-6.21-9.572-6.21-15.41 0-5.896 2.07-11.033 6.21-15.412C57.224 5.416 61.812 3.2 66.79 3.2c1.903 0 3.637.336 5.204 1.01 1.566.674 2.657 1.32 3.273 1.937a10.247 10.247 0 0 1 1.51 1.684ZM61.504 25.347c0 1.852.727 3.537 2.182 5.052 1.455 1.46 3.217 2.19 5.287 2.19s3.777-.758 5.12-2.274c1.398-1.516 2.098-3.172 2.098-4.968 0-1.853-.672-3.565-2.014-5.137-1.287-1.572-3.05-2.358-5.288-2.358-2.182 0-3.972.786-5.37 2.358-1.343 1.572-2.015 3.284-2.015 5.137Zm51.001-16.338c2.63-3.986 5.791-5.979 9.484-5.979 5.706 0 9.959 2.442 12.756 7.327a28.542 28.542 0 0 1 2.182-2.61c.835-.892 2.11-1.831 3.822-2.82l.374-.213c1.903-1.122 3.861-1.684 5.875-1.684 4.476 0 8.225 1.74 11.246 5.221 3.021 3.425 4.532 9.124 4.532 17.096v14.737l-.006.674c-.016.964-.07 1.722-.162 2.273-.05.55-.254 1.187-.613 1.913l-.142.277c-.728 1.516-2.882 2.274-6.462 2.274-3.525 0-5.679-.786-6.463-2.358-.391-.842-.643-1.572-.755-2.19-.05-.612-.079-1.48-.083-2.603l-.001-15.082c0-4.884-1.734-7.326-5.203-7.326-1.958 0-3.301.645-4.029 1.937-.671 1.291-1.007 3.116-1.007 5.474v14.737l-.005.643c-.015 1.022-.07 1.79-.163 2.304-.055.618-.307 1.348-.755 2.19-.783 1.516-2.965 2.274-6.546 2.274-3.525 0-5.679-.786-6.462-2.358-.392-.842-.644-1.572-.755-2.19-.05-.612-.079-1.48-.083-2.603l-.001-15.082c0-4.884-1.735-7.326-5.204-7.326-3.357 0-5.035 2.442-5.035 7.326v14.906l-.006.674c-.016.964-.07 1.722-.162 2.274-.056.617-.308 1.347-.755 2.19-.84 1.459-3.022 2.189-6.546 2.189-3.525 0-5.68-.758-6.463-2.274-.391-.842-.643-1.572-.755-2.19-.056-.617-.084-1.6-.084-2.947V10.441c0-1.291.028-2.246.084-2.863.112-.674.392-1.404.84-2.19.839-1.516 2.825-2.274 5.958-2.274s5.175.506 6.126 1.516c.952 1.01 1.427 2.47 1.427 4.38Zm85.652-1.179c.336-3.144 2.546-4.716 6.63-4.716 2.182 0 3.805.169 4.868.506.981.31 1.676.837 2.086 1.578l.096.19c.447.842.699 1.6.755 2.274.112.617.168 1.572.168 2.863V40l-.006.673c-.016.965-.07 1.723-.162 2.274-.056.618-.28 1.348-.671 2.19-.784 1.46-2.714 2.19-5.791 2.19-3.021 0-5.063-.366-6.127-1.096-1.007-.785-1.594-1.908-1.762-3.368-2.07 2.976-5.539 4.463-10.407 4.463-4.811 0-9.287-2.217-13.427-6.653-4.141-4.435-6.211-9.572-6.211-15.41 0-5.896 2.07-11.033 6.211-15.412 4.196-4.435 8.784-6.652 13.763-6.652 1.902 0 3.637.336 5.203 1.01 1.463.629 2.51 1.233 3.144 1.813l.13.124a10.233 10.233 0 0 1 1.51 1.684Zm-15.274 17.517c0 1.852.727 3.537 2.182 5.052 1.455 1.46 3.217 2.19 5.287 2.19s3.777-.758 5.12-2.274c1.398-1.516 2.098-3.172 2.098-4.968 0-1.853-.672-3.565-2.014-5.137-1.287-1.572-3.05-2.358-5.288-2.358-2.182 0-3.972.786-5.371 2.358-1.343 1.572-2.014 3.284-2.014 5.137Zm61.156-22.233c5.595 0 10.239 2.162 13.931 6.485 3.749 4.267 5.623 9.488 5.623 15.663v14.822l-.006.674c-.016.964-.07 1.722-.162 2.273-.056.618-.279 1.32-.671 2.106-.783 1.516-2.965 2.273-6.546 2.273-3.853 0-6.125-.976-6.821-2.93l-.061-.185c-.336-.955-.503-2.386-.503-4.295V25.178c0-2.302-.672-4.098-2.015-5.39-1.286-1.29-3.049-1.936-5.287-1.936-2.182 0-3.972.673-5.371 2.02-1.343 1.348-2.014 3.117-2.014 5.306v14.906l-.006.674c-.016.964-.07 1.722-.162 2.273-.056.618-.308 1.32-.755 2.106-.728 1.516-2.882 2.273-6.463 2.273-3.524 0-5.678-.757-6.462-2.273-.391-.842-.643-1.572-.755-2.19-.05-.612-.079-1.48-.083-2.603l-.001-30.156c0-1.235.028-2.161.084-2.779.112-.673.392-1.403.839-2.19.783-1.403 2.938-2.105 6.462-2.105 3.413 0 5.511.646 6.295 1.937.559.955.839 2.106.839 3.453.224-.393.727-.954 1.511-1.684.783-.73 1.538-1.32 2.266-1.769 1.902-1.291 4-1.937 6.294-1.937Zm84.453-1.047a7.911 7.911 0 0 1 .543 11.237l-27.15 29.65a8.045 8.045 0 0 1-5.839 2.605 8.05 8.05 0 0 1-5.901-2.468l-14.577-15.187a7.911 7.911 0 0 1 .276-11.246c3.206-3.03 8.282-2.907 11.335.274l8.633 8.994 21.355-23.32c2.977-3.252 8.048-3.493 11.325-.539Z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export const XamanText = memo(_XamanText);
XamanText.displayName = "XamanText";
